import React, { useState, useRef, useEffect, useMemo, useContext } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet-draw/dist/leaflet.draw.css";
import {
  FaChevronDown,
  FaChevronUp,
} from "react-icons/fa";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import booleanPointInPolygon from "@turf/boolean-point-in-polygon";

import { getData, postDataWithBody } from "../../../Services/Services";
import { toast } from "react-toastify";
import { districtsInGis, findAllChildrenRegionsById, getbmskdetails, getcensusdatain, geteventdetails, geteventincidentdata, getfacilitydatasearch, getfacilitydistance, getfacilitytabledata, getGisData, getincidentDatain, getregionincidentdata, getresourceData, getsearchdetails, getshowbasicdet, gisCoordinatesData, gisStateCoordinates, resourcedistance, searchshowlatdetails, updateincident } from "../../../Services/EndPoints";
import { Search, MapPin, AlertTriangle } from 'lucide-react';
import { OpenStreetMapProvider } from 'leaflet-geosearch';
import 'leaflet-geosearch/dist/geosearch.css';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi'
import myImage from '../../../Assets/Images/tableview.png';
import logo from '../../../Assets/Icons/CircleDashed.svg'
import logo1 from '../../../Assets/Icons/Polygon.svg'
import Tree from "rc-tree";
import RegionNode from "../RegionManagement/RegionList/RegionTree/RegionNode";
import RMMap from "../RegionManagement/RMMap/RMMap";
import { useLocation } from "react-router-dom";
import { ThemeContext } from "../../..";
// Custom Icons using SVG strings
const createCustomIcon = (svg, color) => {
  return L.divIcon({
    className: "custom-icon",
    html: `<div style="color: ${color}; font-size: 24px;">${svg}</div>`,
    iconSize: [24, 24],
    iconAnchor: [12, 12],
    popupAnchor: [0, -12],
  });
};

// const incidentIconSvg =
//  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"/></svg>';

//  const incidentIconSvg =
//  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
//   <path fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-17.7 0-32 14.3-32 32V288c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-17.7-14.3-32-32-32zm-32 320a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
// </svg>`

// const incidentIconSvg =
// `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
//  <path fill="currentColor" d="M216 23.86c0-23.8-30.65-32.77-44.15-13.04C48 191.85 224 200 224 288c0 35.63-29.11 64.46-64.85 63.99-35.17-.45-63.15-29.77-63.15-64.94v-85.51c0-21.7-26.47-32.23-41.43-16.5C27.8 213.16 0 261.33 0 320c0 105.87 86.13 192 192 192s192-86.13 192-192c0-170.29-168-193-168-296.14z"/>
// </svg>`

const incidentIconSvg = `  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 512 512"
    {...props}
  >
    <path fill="red" d="M53 33c-1.2 1.2-2 3.3-2 5.3 0 2.9 2.9 6.1 30.3 33.5 32.3 32.2 33.1 32.8 37.7 28.2 1.9-1.9 2.5-3.8 2.1-7-.2-.8-13.8-15.1-30.4-31.8C58.4 28.9 57.7 28.3 53 33M421.3 61.2c-16.6 16.7-30.2 31-30.4 31.8-.4 3.2.2 5.1 2.1 7 4.6 4.6 5.4 4 37.7-28.2C458.1 44.4 461 41.2 461 38.3c0-4.1-3-7.3-6.8-7.3-2.2 0-7.9 5.2-32.9 30.2M234.5 59c-41.4 7.5-74.4 29.9-95.6 64.7-10.4 17.1-16.9 37.4-18.9 58.8-.6 6.6-1 49.7-1 108.7V389h112.8c62.1 0 123.8.3 137.1.7l24.2.6-.4-106.9c-.3-104.3-.4-107.1-2.4-116.4-2.6-11.5-7.3-25.1-12-34.4-18.9-37.6-55.2-65.1-96.4-73.1-13.5-2.6-34.3-2.9-47.4-.5m49.2 55c4.9 3.2 5 2.4-2.7 73.2-3.9 36.5-7.6 68-8.1 70-2 7.7-8.9 13-16.9 13s-14.9-5.3-16.9-13c-1.6-6.1-15.3-135.3-14.6-137.9.6-2.7 3.6-5.5 6.8-6.5 1.2-.4 13-.6 26.2-.5 19.2.2 24.4.5 26.2 1.7M264 299.9c9.1 4.8 12.7 16.2 7.8 24.6-7.3 12.5-24.3 12.5-31.6 0-3.3-5.8-2.7-14 1.4-19.1 3.9-4.9 8.8-7.4 14.4-7.4 2.5 0 6.1.8 8 1.9M2.5 218.5c-1.4 1.3-2.5 3.1-2.5 4 0 2 1.9 5.7 3.4 6.7.6.4 20.5.8 44.2.8 41.9 0 43.1-.1 44.9-2 2.6-2.9 2.4-7.9-.4-10.2-2.2-1.7-5-1.8-44.8-1.8H4.9zM419.9 217.8c-2.8 2.3-3 7.3-.4 10.2 1.8 1.9 3 2 44.9 2 23.7 0 43.6-.4 44.2-.8 1.5-1 3.4-4.7 3.4-6.7 0-.9-1.1-2.7-2.5-4l-2.4-2.5h-42.4c-39.8 0-42.6.1-44.8 1.8M65.6 438.1l-2.6 2v18.4c0 17.7.1 18.5 2.2 20.5 2.2 2 2.4 2 190.9 2 184.2 0 188.7 0 191-1.9s2.4-2.5 2.7-18.2c.4-17.8.1-20-2.8-22.9-2-2-4.1-2-190.4-2H68.3z" />
  </svg>`;

// const incidentIconSvg =
// `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
//   <path fill="currentColor" d="M224 0c-17.7 0-32 14.3-32 32V49.9C119.5 61.4 64 124.2 64 200v33.4c0 45.4-15.5 89.5-43.8 124.9L5.3 377c-5.8 7.2-6.9 17.1-2.9 25.4S14.8 416 24 416H424c9.2 0 17.6-5.3 21.6-13.6s2.9-18.2-2.9-25.4l-14.9-18.6C399.5 322.9 384 278.8 384 233.4V200c0-75.8-55.5-138.6-128-150.1V32c0-17.7-14.3-32-32-32zm0 96h8c57.4 0 104 46.6 104 104v33.4c0 47.9 13.9 94.6 39.7 134.6H72.3C98.1 328 112 281.3 112 233.4V200c0-57.4 46.6-104 104-104h8zm64 352H224 160c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3z"/>
// </svg>`

// const incidentIconSvg =
// `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512">
//   <path fill="currentColor" d="M328.2 255.8h151.6c9.1 0 16.8-7.7 16.2-16.8-5.1-75.8-44.4-142.2-102.5-184.2-7.4-5.3-17.9-2.9-22.7 4.8L290.4 188c22.6 14.3 37.8 39.2 37.8 67.8zm-37.8 67.7c-12.3 7.7-26.8 12.4-42.4 12.4-15.6 0-30-4.7-42.4-12.4L125.2 452c-4.8 7.7-2.4 18.1 5.6 22.4C165.7 493.2 205.6 504 248 504s82.3-10.8 117.2-29.6c8-4.3 10.4-14.8 5.6-22.4l-80.4-128.5zM248 303.8c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zm-231.8-48h151.6c0-28.6 15.2-53.5 37.8-67.7L125.2 59.7c-4.8-7.7-15.3-10.2-22.7-4.8C44.4 96.9 5.1 163.3 0 239.1c-.6 9 7.1 16.7 16.2 16.7z"/>
// </svg>`

// Create icon instances
// const atmIcon = createCustomIcon(atmIconSvg, "#0066cc");
// const branchIcon = createCustomIcon(branchIconSvg, "#006600");
// const incidentIcon = createCustomIcon(incidentIconSvg, "#cc0000");

// Color-coded incident icons based on severity
// eslint-disable-next-line no-unused-vars
const getIncidentIcon = (severity) => {
  const colors = {
    Low: "#c19a6b", // Tan
    Medium: "#a0522d", // Sienna (reddish-brown)
    High: "#cc0000", // Red
    Critical: "#800000", // Maroon
  };

  return createCustomIcon(incidentIconSvg, colors[severity] || "#cc0000");
};

const GisMapview = () => {
  const handle = useFullScreenHandle();
  const [showRegionHierarchy, setShowRegionHierarchy] = useState(true);
  const [showbmsk, setshowbmsk] = useState(false)
  const [showfacilityHierarchy, setShowfacilityHierarchy] = useState(true);
  const [showresourcedata, setshowresourcedata] = useState(true)
  const [selectedType, setSelectedType] = useState('');
  const [kilometerRange, setKilometerRange] = useState(100);
  const [isFullscreen, setIsFullscreen] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [showDistricts, setShowDistricts] = useState(false);
  const [DistrictList, setDistrictList] = useState([]);
  const [districtCoordinates, setDistrictCoordinates] = useState({});
  const [bmskSelectedDistrictIds, setBmskSelectedDistrictIds] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [loader, setLoader] = useState(true); // Start with loader active
  // eslint-disable-next-line no-unused-vars
  const [selectAllState, setSelectAllState] = useState(true);
  const [facilitySearchTerm, setFacilitySearchTerm] = useState('');
  const [showmodel, setshowmodel] = useState(false)
  const [showIncident, setShowIncident] = useState(false);
  const [selectedIncidentId, setSelectedIncidentId] = useState('');
  const [selectincideregionid, setSelectedincidentregionid] = useState('')
  const [modalSearchTerm, setModalSearchTerm] = useState('');
  const [treeData, setTreeData] = useState([]);
  const [checkedKeys, setCheckedKeys] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [showPopup, setShowPopup] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [regionTypeId, setRegionTypeId] = useState(null);
  const [expandedKeys, setExpandedKeys] = useState(["52"]);
  // eslint-disable-next-line no-unused-vars
  const [actionType, setActionType] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [keyVal, setKeyVal] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [actionTypeHeader, setActionTypeHeader] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [id, setId] = useState(null);
  const [districtId, setDistrictId] = useState("");
  const [selectedDistrictIds, setSelectedDistrictIds] = useState([]);
  const [selectedRegions, setSelectedRegions] = useState([]);
  const [selectedBlockIds, setSelectedBlockIds] = useState([]);
  const [selectedPanchayatIds, setSelectedPanchayatIds] = useState([]);
  const [selectedVillageIds, setSelectedVillageIds] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [censusSearchTerm, setCensusSearchTerm] = useState('');
  const [regionSearchTerm, setRegionSearchTerm] = useState('');
  const [eventSearchTerm, setEventSearchTerm] = useState('');
  const [districtSearchTerm, setDistrictSearchTerm] = useState('')
  const [filterDate, setFilterDate] = useState('');
  const [drawCircle, setDrawCircle] = useState(false);
  const [circleRadius, setCircleRadius] = useState(0);
  const [clearCircles, setClearCircles] = useState(false);
  const [facilityCoordinates, setFacilityCoordinates] = useState([]);
  const [bmskdetails, setbmskdetails] = useState([])
  const [filteredFacilities, setFilteredFacilities] = useState([]);
  const { state } = useLocation();
  const [isKilometerEnabled, setIsKilometerEnabled] = useState(false);
  let tabvv = state?.tabvv;
  let inciden_mapid = state?.id;
  const [clickedPoint, setClickedPoint] = useState(null);
  const [activeTab, setActiveTab] = useState(tabvv ? "Incident" : "Region");
  const regionDataMap = useRef(new Map()).current;
  const [mapData, setMapData] = useState({
    branches: [],
    atms: [],
    incidents: [],
    events: []
  });
  const [selectedLayers, setSelectedLayers] = useState({
    regionLayer: true,
    state: false,
    block: true,
  });
  const [facilities, setFacilities] = useState([]);
  const [searchCoordinates, setSearchCoordinates] = useState(null);
  const [facilityData, setFacilityData] = useState([]);
  const [resourcedata, setResourcedata] = useState([]);
  const [incidentdata, setincidentdata] = useState([]);
  const [bmskActiveDistricts, setBmskActiveDistricts] = useState({});
  const [bmskSelectAllDistricts, setBmskSelectAllDistricts] = useState(false);
  const [expandedSections, setExpandedSections] = useState({
    attribute: true,
    regions: true,
    events: true
  });
  const [basicindata, setbasicindata] = useState([])
  const [censusdata, setcensusdata] = useState([])
  const [regiondata, setregiondata] = useState([])
  const [eventdata, seteventdata] = useState([])
  const [drawPolygon, setDrawPolygon] = useState(false);
  const [clearPolygons, setClearPolygons] = useState(false);
  const { theme } = useContext(ThemeContext);
  const [activeDrawMode, setActiveDrawMode] = useState(null);

  const handleDrawPolygon = () => {
    // turn off circle mode
    setDrawCircle(false);
    setClearCircles(true);

    setDrawPolygon(true);
    setClearPolygons(false);
    setClickedPoint(null);
    setActiveDrawMode('polygon');
    setTimeout(() => {
      setDrawPolygon(false);
      setClearCircles(false);
    }, 100);
  };

  const handleClearPolygons = () => {
    setClearPolygons(true);
    setDrawPolygon(false);
    setClickedPoint(null);        // ← ADD THIS LINE
    setFilteredFacilities([]);    // ← ADD THIS LINE
    setActiveDrawMode(null);
    setDrawnShapes([]);
    setTimeout(() => {
      setClearPolygons(false);
    }, 100);
  };

  const handleLocationSelect = (coords) => {
    setCoordinates(coords);
    // Update form values

    if (coords) {
      //setIsKilometerEnabled(false)
    }

  }
  useEffect(() => {
    if (inciden_mapid) {
      setIsChecked(true);
    } else {
      setIsChecked(false);
    }
  }, [inciden_mapid]);
  useEffect(() => {
    if (activeTab === 'Search') {
      // setSelectAllDistricts(false)
      // setActiveDistricts({})
      // setSelectedDistrictIds([])
      // setBmskSelectAllDistricts(false)
      // setBmskActiveDistricts({})
      setSelectedPanchayatIds([])
      // setSelectedBlockIds([])
      //setSelectedVillageIds([])
      // setCheckedKeys([]);
      // setbmskdetails([])
      // setBmskSelectedDistrictIds([])
      setMapData(prev => ({
        ...prev,
        events: []
      }));
      setIsChecked(false)
      setSelectedIncidentId('');
      setSearchCoordinates(null);


    } else if (activeTab === 'Incident') {
      // setSelectAllDistricts(false)
      // setActiveDistricts({})
      // setSelectedDistrictIds([])
      // setSelectedPanchayatIds([])
      setFacilityCoordinates([]);
      setFilteredFacilities([])
      setBmskSelectAllDistricts(false)
      setBmskActiveDistricts({})
      // setSelectedBlockIds([])
      // setSelectedVillageIds([])
      setbmskdetails([])
      setBmskSelectedDistrictIds([])
      setSearchCoordinates(null)
      setFacilities(prevFacilities =>
        prevFacilities.map(facility => ({
          ...facility,
          selected: false
        }))
      );
      handleClearCircles();
      handleClearPolygons();
      //  setCheckedKeys([]);
      setIsKilometerEnabled(false)
      setClickedPoint(null)
    } else if (activeTab === 'Region') {
      setSelectedPanchayatIds([])
      setFacilityCoordinates([]);
      setFilteredFacilities([])

      setFacilities(prevFacilities =>
        prevFacilities.map(facility => ({
          ...facility,
          selected: false
        }))
      );
      handleClearCircles();
      handleClearPolygons();
      setMapData(prev => ({
        ...prev,
        events: []
      }));
      setIsKilometerEnabled(false)
      setClickedPoint(null)
      setIsChecked(false)
      setSelectedIncidentId('');
      setSearchCoordinates(null);

    }
  }, [activeTab])



  const handleDrawCircle = (radius) => {
    setCircleRadius(radius);

    // turn off polygon mode
    setDrawPolygon(false);
    setClearPolygons(true);

    setDrawCircle(true);
    setClearCircles(false);
    setClickedPoint(null);
    setActiveDrawMode('circle');
    // reset flags
    setTimeout(() => {
      setDrawCircle(false);
      setClearPolygons(false);
    }, 100);
  };


  // Function to clear circles
  const handleClearCircles = () => {
    setClearCircles(true);
    setDrawCircle(false);
    setClickedPoint(null);        // ← ADD THIS LINE
    setFilteredFacilities([]);    // ← ADD THIS LINE
    setActiveDrawMode(null);      // ← ADD THIS LINE
    setDrawnShapes([]);
    setTimeout(() => {
      setClearCircles(false);
    }, 100);
  };
  console.log("DistrictList", DistrictList)
  useEffect(() => {
    if (inciden_mapid && incidentdata.length > 0) {
      // Find the incident that matches the inciden_mapid
      const matchingIncident = incidentdata.find(item => item.value === inciden_mapid);
      console.log("maching id", matchingIncident)
      console.log("incdddddd", incidentdata)
      if (matchingIncident) {
        setSelectedIncidentId(matchingIncident.value);
        // Also fetch the related data for this incident
        getshowincidata(matchingIncident.value);
        getcensusdata(selectincideregionid);
        getregiondata(matchingIncident.value);
        geteventdata(matchingIncident.value);
        // setShowIncident(true);
        geteventmapdetails(matchingIncident.value)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inciden_mapid, incidentdata,]);


  const geteventmapdetails = async (id) => {
    try {

      const event_resp = await postDataWithBody(geteventdetails, [id], {})
      if (event_resp && event_resp.length > 0) {
        // Process the response to create markers data
        const eventMarkers = event_resp.map(event => ({
          id: event.id,
          position: [event.lat, event.lng], // Using lat/lng from the response
          incidentId: event.incidentId,
          incidentName: event.incidentName,
          status: event.status,
          action: event.action,
          files: event.files,
          createdBy: event.createdBy,
          incidentCategory: event.incidentCategory,
          eventTime: event.eventTime,
          userName: event.userName,
          jobTitle: event.jobTitle,
          mobileNumber: event.mobileNumber
        }));

        // Update the map data state with these events
        setMapData(prev => ({
          ...prev,
          events: eventMarkers
        }));
      }

    } catch (error) {

    }
  }
  const handleSelectChange = (e) => {
    setSelectedType(e.target.value);

  };
  useEffect(() => {
    if (selectedIncidentId) {
      getregiondetails(selectedIncidentId)
    }
  }, [selectedIncidentId])


  const getregiondetails = async (id) => {
    try {
      const ince_region = await postDataWithBody(updateincident, [id], {})
      setSelectedPanchayatIds([]);
      if (ince_region?.regions?.length > 0) {
        const panchayatIds = ince_region.regions
          .map(region => region.gis_id)
          .filter(gis_id => gis_id !== null);

        setSelectedPanchayatIds(panchayatIds);


      }


    } catch (error) {
      setSelectedPanchayatIds([]);
    }

  }
  useEffect(() => {
    console.log('Tree data loaded:', treeData);
    console.log('Number of nodes:', treeData.length);
  }, [treeData]);
  const toggleSection = (section) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };
  useEffect(() => {
    window.regionTreeComponent = {
      showModalPopup,
      hideModalPopup
    };

    // Add Bihar to the regionDataMap
    regionDataMap.set("52", {
      name: "BIHAR",
      id: 52,
      region_type_id: null,
      gis_id: null,
      level: 0
    });

    // Initialize with Bihar checked
    const initializeTree = async () => {
      const rootNode = {
        title: "BIHAR",
        key: "52",
        checkable: true
      };
      setTreeData([rootNode]);
      setExpandedKeys(["52"]);

      // First load district data for Bihar
      const biharChildren = await generateTreeNodes({ props: { eventKey: "52" } });
      const newTreeData = [rootNode];
      getNewTreeData(newTreeData, "52", biharChildren, 5);
      setTreeData(newTreeData);

      // Now check Bihar and all districts
      const allDistrictKeys = biharChildren.map(child => child.key);
      const allDistrictGisIds = [];
      const allSelectedRegions = [];

      biharChildren.forEach(child => {
        const childData = regionDataMap.get(child.key);
        if (childData && childData.gis_id) {
          allDistrictGisIds.push(childData.gis_id);
          allSelectedRegions.push({
            name: childData.name,
            gis_id: childData.gis_id,
            id: childData.id,
            region_type_id: childData.region_type_id,
            level: childData.level
          });
        }
      });

      // Check Bihar and all districts
      setCheckedKeys(["52", ...allDistrictKeys]);
      setSelectedRegions(allSelectedRegions);
      setSelectedDistrictIds(allDistrictGisIds);
    };

    initializeTree();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    getFacilityData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    gerResourceData()
    getinicdentData()
    // getbmskdetails1();

  }, [])
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  // 👇 replace with your real API call
  const fetchService = async (searchText) => {
    const name = { name: searchText + "%" };
    
    setLoading(true);
    try {
      const res = await postDataWithBody(getsearchdetails, name, {});

      const filteredData = res.filter(item =>
        item.child_id.toLowerCase().includes(searchText.toLowerCase()) ||
        item.parent_first_name.toLowerCase().includes(searchText.toLowerCase())
      );

      setResults(filteredData);
    } catch (err) {
      console.error("API Error:", err);
      setResults([]);
    } finally {
      setLoading(false);
    }
  };


  // 👇 Debounced call (fires 400ms after user stops typing)
  useEffect(() => {
    if (query.trim().length > 0) {
      const delay = setTimeout(() => {
        fetchService(query);
      }, 400);
      return () => clearTimeout(delay);
    } else {
      setResults([]);
    }
  }, [query]);

  const getbmskdetails1 = async (date, districts) => {
    const selectedDistricts = Object.keys(districts).filter(
      district => districts[district] === true
    );
    try {
      const request = {
        from_date: date,
        districts: selectedDistricts
      }
      const response = await postDataWithBody(getbmskdetails, request, {})
      if (response && Array.isArray(response)) {
        // Extract required data for RMMAP (latitude, longitude, and other details)
        const mappedData = response.map((station) => ({
          id: station.id,
          district: station.district,
          latitude: parseFloat(station.latitude), // Ensure it's a number
          longitude: parseFloat(station.longitude), // Ensure it's a number
          humidity: station.humidity,
          rainfall: station.rainfall,
          temperature: station.temperature,
          windSpeed: station.wind_speed,
          reportedOn: station.reported_on, // Timestamp (if needed)
        }));

        console.log("Mapped Data for RMMAP:", mappedData);
        setbmskdetails(mappedData)

        // Optional: return if needed elsewhere
      } else {
        console.warn("No valid data received from BMSK API");
        return [];
      }
    } catch (error) {

    }
  }
  const getshowincidata = async (selectid) => {
    try {
      console.log("selectdd", selectid)
      const res_ponse = await postDataWithBody(getshowbasicdet, [selectid], {})
      console.log("res_ponse regionids", res_ponse[0].region_ids)
      if (res_ponse) {
        setbasicindata(res_ponse)
        setSelectedincidentregionid(res_ponse[0].region_ids)
      }
      console.log("res", res_ponse)
    } catch (error) {

    }
  }
  const getcensusdata = async (selecenid) => {

    console.log(selecenid, "dataaaaaaaaaaaaaaaaa")
    try {
      const cenres = await postDataWithBody(getcensusdatain, [selecenid], {})
      if (cenres) {
        setcensusdata(cenres)
      }
    } catch (error) {

    }
  }
  const getregiondata = async (selecid) => {
    try {
      const regiondata = await postDataWithBody(getregionincidentdata, [selecid], {})
      if (regiondata) {
        setregiondata(regiondata)
      }
    } catch (error) {

    }
  }
  const geteventdata = async (seleceveid) => {
    try {
      const eventdata = await postDataWithBody(geteventincidentdata, [seleceveid], {})
      if (eventdata) {
        seteventdata(eventdata)
      }
    } catch (error) {

    }
  }
  const getinicdentData = async () => {
    try {
      const incidentdata = await getData(getincidentDatain)
      if (incidentdata) {
        setincidentdata(incidentdata)
      }
    } catch (error) {

    }
  }

  const gerResourceData = async () => {
    try {
      const res = await getData(getresourceData)
      if (res) {
        setResourcedata(res)
      }
    }
    catch (error) {

    }
  }
  const getFacilityData = async () => {
    const response = await getData(getfacilitydatasearch);
    if (response) {
      const processed = response.map(f => ({
        ...f,
        latitude: parseFloat(f.latitude),
        longitude: parseFloat(f.longitude),
        selected: false
      }));
      setFacilities(processed);
    }
  };
  const hideModalPopup = () => {
    setShowPopup(false);
  };
  console.log("data", treeData)
  const onLoadData = (treeNode) => {
    console.log("load data...");
    return new Promise(async (resolve, reject) => {
      const newTreeData = [...treeData];
      let regionList = await generateTreeNodes(treeNode);
      getNewTreeData(newTreeData, treeNode.props.eventKey, regionList, 5); // Increased level to accommodate villages
      setTreeData(newTreeData);
      resolve();
    });
  };
  // eslint-disable-next-line no-unused-vars
  const onLoadData1 = (treeNode) => {
    console.log("load data...");
    return new Promise(async (resolve, reject) => {
      const newTreeData = [...treeData];
      let regionList = await generateTreeNodes(treeNode);
      getNewTreeData(newTreeData, treeNode.props.eventKey, regionList, 1); // Increased level to accommodate villages
      setTreeData(newTreeData);
      resolve();
    });
  };
  const generateTreeNodes = async (treeNode) => {
    const arr = [];
    const key = treeNode.props.eventKey;
    // eslint-disable-next-line no-unused-vars
    const { keySanitized, level, isLastNode } = getHierarchyInfo(key);

    const rgnList = await postDataWithBody(findAllChildrenRegionsById, [keySanitized], {});

    rgnList.forEach(function (region) {
      let keyVal = `${key}-${region.id}`;

      // Store region data in the map with the key for later reference
      regionDataMap.set(keyVal, {
        name: region.name,
        id: region.id,
        region_type_id: region.region_type_id,
        gis_id: region.gis_id,
        level: level + 1
      });

      // Also store the data with just the ID as key for easy lookup
      regionDataMap.set(region.id.toString(), {
        name: region.name,
        id: region.id,
        region_type_id: region.region_type_id,
        gis_id: region.gis_id,
        level: level + 1
      });

      // Determine if this new node will be a leaf (Village level)
      const newLevel = level + 1;
      const willBeLeaf = newLevel >= 4; // Village level (4) is leaf

      arr.push({
        title: (
          <RegionNode
            regionTypeId={region.region_type_id}
            isLastNode={willBeLeaf}
            keyVal={keyVal}
            selectedId={handleSelectedId}
            id={region.id}
            text={region.name}
            displayNewUI={true}
          />
        ),
        key: keyVal,
        isLeaf: willBeLeaf,
        checkable: true,
      });
    });

    return arr;
  };
  const getHierarchyInfo = (key) => {
    let keySanitized = null;
    let level = 0;
    let isLastNode = false;

    if (key.indexOf("-") > -1) {
      const keyParts = key.split("-");
      level = keyParts.length - 1; // 1=District, 2=Block, 3=Panchayat, 4=Village

      // Village is the last level (level 4)
      if (keyParts.length === 5) { // Bihar-District-Block-Panchayat-Village
        isLastNode = true;
      }
      keySanitized = keyParts[keyParts.length - 1];
    } else {
      keySanitized = key;
      level = 0; // Bihar level
    }

    return { keySanitized, level, isLastNode };
  };
  const setLeaf = (treeData, curKey, level) => {
    const loopLeaf = (data, lev) => {
      const l = lev - 1;
      data.forEach((item) => {
        if (
          item.key.length > curKey.length
            ? item.key.indexOf(curKey) !== 0
            : curKey.indexOf(item.key) !== 0
        ) {
          return;
        }
        if (item.children) {
          loopLeaf(item.children, l);
        } else if (l < 1) {
          item.isLeaf = true;
        }
      });
    };
    loopLeaf(treeData, level + 1);
  };
  const getNewTreeData = (treeData, curKey, child, level) => {
    const loop = (data) => {
      if (level < 1) return;
      data.forEach((item) => {
        if (curKey.indexOf(item.key) === 0) {
          if (item.children) {
            loop(item.children);
          } else {
            item.children = child;
          }
        }
      });
    };
    loop(treeData);
    setLeaf(treeData, curKey, level);
  };
  const getAllChildKeys = (treeData, parentKey) => {
    const childKeys = [];

    const findChildren = (nodes) => {
      nodes.forEach(node => {
        if (node.key.startsWith(parentKey + '-')) {
          childKeys.push(node.key);
          if (node.children) {
            findChildren(node.children);
          }
        }
      });
    };

    findChildren(treeData);
    return childKeys;
  };
  const handleSelectedId = (idval, type, keyVal, regionTypeId) => {
    showModalPopup(idval, type, keyVal, regionTypeId);
  };
  const showModalPopup = (id, type, keyVal, regionTypeId) => {
    let actionTypeStr = type === "EDIT" ? "Edit Region Information" : "Create Region";
    setRegionTypeId(regionTypeId);
    setShowPopup(true);
    setActionType(type);
    setKeyVal(keyVal);
    setActionTypeHeader(actionTypeStr);
    setId(id);
  };
  const processIndividualNode = async (nodeKey, regionData, checkedKeys, regions, districts, blocks, panchayats, villages, isChecking) => {
    if (isChecking) {
      // Add current node
      if (regionData.gis_id) {
        // eslint-disable-next-line default-case
        switch (regionData.level) {
          case 1: // District
            districts.push(regionData.gis_id);
            break;
          case 2: // Block
            blocks.push(regionData.gis_id);
            break;
          case 3: // Panchayat
            panchayats.push(regionData.gis_id);
            break;
          case 4: // Village
            villages.push(regionData.gis_id);
            break;
        }
      }

      regions.push({
        name: regionData.name,
        gis_id: regionData.gis_id,
        id: regionData.id,
        region_type_id: regionData.region_type_id,
        level: regionData.level
      });

      // Also check all children if this is not a leaf node
      if (regionData.level < 4) {
        const allChildKeys = getAllChildKeys(treeData, nodeKey);
        for (const childKey of allChildKeys) {
          if (!checkedKeys.includes(childKey)) {
            checkedKeys.push(childKey);
            const childData = regionDataMap.get(childKey);
            if (childData) {
              regions.push({
                name: childData.name,
                gis_id: childData.gis_id,
                id: childData.id,
                region_type_id: childData.region_type_id,
                level: childData.level
              });

              if (childData.gis_id) {
                // eslint-disable-next-line default-case
                switch (childData.level) {
                  case 1: districts.push(childData.gis_id); break;
                  case 2: blocks.push(childData.gis_id); break;
                  case 3: panchayats.push(childData.gis_id); break;
                  case 4: villages.push(childData.gis_id); break;
                }
              }
            }
          }
        }
      }
    } else {
      // Unchecking - remove current node and all children
      const keysToRemove = [nodeKey, ...getAllChildKeys(treeData, nodeKey)];

      for (const keyToRemove of keysToRemove) {
        // Remove from checked keys
        const index = checkedKeys.indexOf(keyToRemove);
        if (index > -1) {
          checkedKeys.splice(index, 1);
        }

        // Remove from regions and category arrays
        const dataToRemove = regionDataMap.get(keyToRemove);
        if (dataToRemove) {
          // Remove from regions
          const regionIndex = regions.findIndex(r => r.id === dataToRemove.id);
          if (regionIndex > -1) {
            regions.splice(regionIndex, 1);
          }

          // Remove from appropriate category
          if (dataToRemove.gis_id) {
            // eslint-disable-next-line default-case
            switch (dataToRemove.level) {
              case 1:
                removeFromArray(districts, dataToRemove.gis_id);
                break;
              case 2:
                removeFromArray(blocks, dataToRemove.gis_id);
                break;
              case 3:
                removeFromArray(panchayats, dataToRemove.gis_id);
                break;
              case 4:
                removeFromArray(villages, dataToRemove.gis_id);
                break;
            }
          }
        }
      }
    }
  };
  const removeFromArray = (array, item) => {
    const index = array.indexOf(item);
    if (index > -1) {
      array.splice(index, 1);
    }
  };


  const toggleFacilitySelect = (facilityId) => {
    setFacilities(prevFacilities =>
      prevFacilities.map(facility =>
        facility.id === facilityId
          ? { ...facility, selected: !facility.selected }
          : facility
      )
    );
  };

  // Toggle select all facilities
  const toggleSelectAllFacilities = () => {
    const allSelected = facilities.every(f => f.selected);
    setFacilities(prevFacilities =>
      prevFacilities.map(facility => ({
        ...facility,
        selected: !allSelected
      }))
    );
  };
  const fetchFacilityData = async (selectedIds) => {
    try {
      const validIds = selectedIds.filter(id => id !== undefined && id !== null && id !== '');
      console.log("iiii", selectedIds)
      const response = await postDataWithBody(getfacilitytabledata, validIds, {})
      if (response) {
        setFacilityData(response);
      }

    } catch (error) {

    }

  }

  // Handle facility search

  const handleFacilitySearch = async () => {
    if (!coordinates.latitude || !coordinates.longitude) {
      toast.error("Please select a location on the map first by clicking on it", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000, // Close after 2 seconds
      });
      return;
    }
    try {
      const req = {
        lat: coordinates.latitude,
        lng: coordinates.longitude,
        distance: kilometerRange * 1000
      };

      const response = await postDataWithBody(getfacilitydistance, req, {});

      if (!response || !Array.isArray(response)) {
        setFacilityCoordinates([]);
        toast.info("No facilities found in this range");
        return [];
      }

      // Process the response to extract coordinates
      const facilityCoords = response.map(facility => {
        try {
          const coordData = JSON.parse(facility.coordinates);
          return {
            id: facility.id?.toString(), // Ensure ID is string
            position: coordData.coordinates?.reverse() || [0, 0], // Fallback position
            name: facility.facility_name || `Facility ${facility.id}`,
            address: facility.facility_address || 'Address not available'
          };
        } catch (e) {
          console.error("Error parsing facility coordinates:", e);
          return null;
        }
      }).filter(Boolean); // Remove any null entries from failed parsing
      // eslint-disable-next-line no-unused-vars
      const foundFacilityIds = facilityCoords.map(f => f.id);

      // setFacilities(prevFacilities =>
      //   prevFacilities.map(facility => {
      //     // Safely handle undefined/null IDs
      //     const facilityId = facility?.id;
      //     return {
      //       ...facility,
      //       selected: facilityId ? foundFacilityIds.includes(facilityId.toString()) : false
      //     };
      //   })
      // );

      setFacilityCoordinates(facilityCoords);
      // toast.success(`${facilityCoords.length} facilities found`);
      return facilityCoords;
    } catch (error) {
      console.error("Error searching facilities:", error);
      // toast.error("Failed to search facilities");
      return [];
    }
  };
  const searhdisresource = async () => {
    try {
      const comparefacility = await handleFacilitySearch();
      const req = {
        lat: coordinates.latitude,
        lng: coordinates.longitude,
        distance: kilometerRange * 1000,
        resourceactivity: selectedType
      };

      console.log('Sending request to resourcedistance with:', req);
      const resourceResponse = await postDataWithBody(resourcedistance, req, {});
      console.log('Resource API response:', resourceResponse);

      // Handle case where API returns an array of strings (IDs)
      const resourceIds = Array.isArray(resourceResponse)
        ? resourceResponse.map(id => String(id)).filter(Boolean)
        : [];

      console.log('Resource IDs to search:', resourceIds);

      // Filter facilities that match the resource IDs
      const facilityCoords = Array.isArray(comparefacility)
        ? comparefacility.filter(facility => {
          const facilityId = facility?.id?.toString();
          return facilityId && resourceIds.includes(facilityId) && !facility.is_deleted;
        }).map(facility => ({
          id: facility.id?.toString(),
          position: facility.position || [0, 0], // Use existing position
          name: facility.facility_name || `Facility ${facility.id}`,
          address: facility.facility_address || 'Address not available'
        }))
        : [];

      console.log('Final facility coordinates:', facilityCoords);

      if (facilityCoords.length > 0) {
        setFacilityCoordinates(facilityCoords);
        //toast.success(`${facilityCoords.length} matching facilities found`);
      } else {
        setFacilityCoordinates([]);
        const allFacilityIds = Array.isArray(comparefacility)
          ? comparefacility.map(f => f?.id?.toString()).filter(Boolean)
          : [];
        const missingIds = resourceIds.filter(id => !allFacilityIds.includes(id));
        console.log('IDs not found in facility data:', missingIds);
        toast.info(`No matching facilities found. ${missingIds.length > 0
          ? `${missingIds.length} IDs not in facility data`
          : 'No facilities matched the search criteria'
          }`);
      }

      return facilityCoords;
    } catch (error) {
      console.error("Error in searchdisresource:", error);
      //toast.error("Failed to search resources");
      return [];
    }
  };

  // Clear facility selections
  const clearFacilitySelections = () => {
    setFacilities(prevFacilities =>
      prevFacilities.map(facility => ({
        ...facility,
        selected: false
      }))
    );
    setFacilitySearchTerm('');
    setFacilityCoordinates([]);
    setSelectedPoint(null);
    setClickedPoint(null)
    setIsKilometerEnabled(false)


  };

  const [drawnShapes, setDrawnShapes] = useState([]);

  const [filteredEntities, setFilteredEntities] = useState({
    branches: null,

    atms: null,

    incidents: null,
    facilities: null,
  });

  const [stateGeoJSON, setStateGeoJSON] = useState([]);

  const [activeDistricts, setActiveDistricts] = useState({});
  // const [showDistricts, setShowDistricts] = useState(false); // Controls visibility
  const [selectAllDistricts, setSelectAllDistricts] = useState(false); // Controls selection

  // Create a list of unique districts from branches
  // eslint-disable-next-line no-unused-vars
  const [districts, setDistricts] = useState([]);
  const [coordinates, setCoordinates] = useState({
    latitude: null,
    longitude: null
  });
  // eslint-disable-next-line no-unused-vars
  const [loadingDistricts, setLoadingDistricts] = useState(false);
  // Add this new state variable near your other useState declarations
  // eslint-disable-next-line no-unused-vars
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedPoint, setSelectedPoint] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [showRangeCircle, setShowRangeCircle] = useState(false);

  // eslint-disable-next-line no-unused-vars
  const drawRef = useRef();

  useEffect(() => {
    fetchGisData();
    fetchDistrictList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    // fetchCoordinates();
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
  useEffect(() => {
    if (selectAllState) {
      mapStateCoordinates();
    } else {
      setStateGeoJSON([])
    }
  }, [selectAllState])

  // Extract unique districts from branches after data is loaded
  useEffect(() => {
    if (mapData.branches.length > 0) {
      const uniqueDistricts = [
        ...new Set(mapData.branches.map((branch) => branch.district)),
      ];
      setDistricts(uniqueDistricts);
    }
  }, [mapData.branches]);



  // Add this filtered districts computation after your other useMemo hooks
  // eslint-disable-next-line no-unused-vars
  const filteredDistricts = useMemo(() => {
    if (!searchTerm.trim()) {
      return DistrictList;
    }
    return DistrictList.filter((district) =>
      district.value.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [DistrictList, searchTerm]);
  // eslint-disable-next-line no-unused-vars
  const filterFacilitiesInRadius = (center, radiusKm) => {
    return facilities.filter(facility => {
      const distance = calculateDistance(
        center[0],
        center[1],
        facility.latitude,
        facility.longitude
      );
      return distance <= radiusKm;
    });
  };

  // Helper distance calculation
  const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371; // Earth radius in km
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  };

  // Filter facilities within polygon
  // eslint-disable-next-line no-unused-vars
  const filterFacilitiesInPolygon = (polygon) => {
    return facilities.filter(facility => {
      return booleanPointInPolygon(
        [facility.longitude, facility.latitude],
        polygon
      );
    });
  };


  // Add this function to filter data by distance
  const filterDataByDistance = (data, centerPoint, radiusKm) => {
    if (!centerPoint || !data) return data;

    return data.filter((item) => {
      const distance = calculateDistance(
        centerPoint[0],
        centerPoint[1],
        item.position[0],
        item.position[1]
      );
      return distance <= radiusKm;
    });
  };
  // eslint-disable-next-line no-unused-vars
  const filterEntitiesInShapes = (shapes) => {
    if (!shapes || shapes.length === 0) {
      setFilteredEntities({
        branches: null,
        atms: null,
        incidents: null,
        facilities: null, // ✅ Reset this too
      });
      return;
    }

    const filterEntity = (entity, type) => {
      return entity.filter((item) => {
        const point =
          type === "facility"
            ? [parseFloat(item.latitude), parseFloat(item.longitude)]
            : [parseFloat(item.position[0]), parseFloat(item.position[1])];

        return shapes.some((shape) => {
          if (shape.properties?.isCircle) {
            const distance = calculateDistance(
              shape.properties.center[0],
              shape.properties.center[1],
              point[0],
              point[1]
            );
            return distance <= shape.properties.radius / 1000;
          } else {
            return booleanPointInPolygon(
              [point[1], point[0]], // lng, lat for turf
              shape
            );
          }
        });
      });
    };

    setFilteredEntities({
      branches: filterEntity(mapData.branches),
      atms: filterEntity(mapData.atms),
      incidents: filterEntity(mapData.incidents),
      facilities: filterEntity(facilities, "facility"), // ✅ Include facilities
    });
  };



  const districtFilteredData = useMemo(() => {
    const activeDistrictNames = Object.keys(activeDistricts).filter(
      (district) => activeDistricts[district]
    );

    // If no districts are selected or "select all" is active, return all data
    if (activeDistrictNames.length === 0 || selectAllDistricts) {
      return mapData;
    }

    return {
      branches: mapData.branches.filter((branch) =>
        activeDistrictNames.includes(branch.district)
      ),
      atms: mapData.atms.filter((atm) =>
        activeDistrictNames.includes(atm.district)
      ),
      incidents: mapData.incidents.filter((incident) =>
        activeDistrictNames.includes(incident.district)
      ),
    };
  }, [mapData, activeDistricts, selectAllDistricts]);
  // eslint-disable-next-line no-unused-vars
  const combinedFilteredData = useMemo(() => {
    // Start with district filtered data
    let baseData = districtFilteredData;

    // Apply drawn shapes filter if exists and has values
    const hasShapeFilters =
      filteredEntities.branches !== null ||
      filteredEntities.atms !== null ||
      filteredEntities.incidents !== null;

    if (hasShapeFilters) {
      baseData = {
        branches:
          filteredEntities.branches !== null
            ? filteredEntities.branches.filter((branch) =>
              districtFilteredData.branches.some((b) => b.id === branch.id)
            )
            : districtFilteredData.branches,
        atms:
          filteredEntities.atms !== null
            ? filteredEntities.atms.filter((atm) =>
              districtFilteredData.atms.some((a) => a.id === atm.id)
            )
            : districtFilteredData.atms,
        incidents:
          filteredEntities.incidents !== null
            ? filteredEntities.incidents.filter((incident) =>
              districtFilteredData.incidents.some((i) => i.id === incident.id)
            )
            : districtFilteredData.incidents,
      };
    }

    // Apply distance filter if a point is selected (only in Search tab)
    if (activeTab === "Search" && selectedPoint) {
      baseData = {
        branches: filterDataByDistance(
          baseData.branches,
          selectedPoint,
          kilometerRange
        ),
        atms: filterDataByDistance(
          baseData.atms,
          selectedPoint,
          kilometerRange
        ),
        incidents: filterDataByDistance(
          baseData.incidents,
          selectedPoint,
          kilometerRange
        ),
      };
    }

    return baseData;
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      districtFilteredData,
      filteredEntities,
      selectedPoint,
      kilometerRange,
      activeTab,
    ]);
  // eslint-disable-next-line no-unused-vars
  const handleMapClick = (e) => {
    console.log("Map clicked at:", e.latlng); // This should now appear in console

    if (activeTab === "Search") {
      const { lat, lng } = e.latlng;
      setSelectedPoint([lat, lng]);
      setShowRangeCircle(true);

      // For debugging
      console.log(`Search point set at: ${lat}, ${lng}`);
      console.log(`Current range: ${kilometerRange}km`);
    }
  };


  // Update the handleDrawDeleted function to properly reset filters


  const fetchGisData = async () => {
    try {
      const response = await getData(getGisData);
      if (response) {
        // Process the data
        processResponseData(response);
      } else {
        console.error("Invalid data format:", response);
        toast.error("Failed to load GIS data");
      }
    } catch (error) {
      console.error("Error fetching GIS data:", error);
      toast.error("Failed to load GIS data");
    }
  };
  // eslint-disable-next-line no-unused-vars
  const [searchResult, setSearchResult] = useState(null);
  const mapRef = useRef();

  // Add this useEffect to initialize the map reference
  useEffect(() => {
    if (mapRef.current) return;
    mapRef.current = mapRef;
  }, []);

  // Add this function to handle location search
  // eslint-disable-next-line no-unused-vars
  const handleLocationSearch = async (query) => {
    try {
      const provider = new OpenStreetMapProvider();
      const results = await provider.search({ query });

      if (results && results.length > 0) {
        const firstResult = results[0];
        setSearchResult({
          position: [firstResult.y, firstResult.x],
          label: firstResult.label
        });

        // Center the map on the searched location
        if (mapRef.current) {
          mapRef.current.setView([firstResult.y, firstResult.x], 15);
        }
      } else {
        toast.error("Location not found");
      }
    } catch (error) {
      console.error("Error searching location:", error);
      toast.error("Failed to search location");
    }
  };

  // Process the response data into the format needed for the map
  const processResponseData = (data) => {
    // Check if the data has the expected structure
    if (!data.branches_list || !data.atms_list || !data.incidents_list) {
      console.error("Data missing required lists");
      // toast.error("Data format is incorrect");
      return;
    }

    // Transform branches data
    const branches = data.branches_list.map((branch) => ({
      id: branch.id,
      name: branch.branchName,
      position: [
        parseFloat(branch.latitude) || 25.59, // Fallback coordinates if missing
        parseFloat(branch.longitude) || 85.13,
      ],
      manager:
        branch.branch_contact && branch.branch_contact.length > 0
          ? `${branch.branch_contact[0].firstName} ${branch.branch_contact[0].lastName}`
          : "N/A",
      phones: branch.phoneNumber || "N/A",
      email: branch.email || "N/A",
      address: `${branch.addressLine1} ${branch.addressLine2 || ""}`,
      district: branch.district || "N/A",
      ifscCode: branch.ifscCode || "N/A",
      // Include original data to access all fields if needed
      originalData: branch,
    }));

    // Transform ATMs data
    const atms = data.atms_list.map((atm) => ({
      id: atm.id,
      name: atm.name,
      position: [
        parseFloat(atm.latitude) || 25.59, // Fallback coordinates if missing
        parseFloat(atm.longitude) || 85.13,
      ],
      status: atm.activeStatus ? "Working" : "Inactive",
      code: atm.code || "N/A",
      address: atm.addressLine || "N/A",
      district: atm.district || "N/A",
      // Include original data
      originalData: atm,
    }));

    // Replace this section in the processResponseData function:

    // Transform incidents data
    const incidents = data.incidents_list.map((incident) => {
      // Format date to dd/mm/yy
      const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = String(date.getFullYear()).slice(-2); // Get last 2 digits of year
        return `${day}/${month}/${year}`;
      };

      return {
        id: incident.id,
        type: incident.incidentName,
        position: [
          parseFloat(incident.latitude) || 25.59, // Fallback coordinates if missing
          parseFloat(incident.longitude) || 85.13,
        ],
        severity: incident.severityLevel || "Medium",
        date: formatDate(incident.incidentDateAndTime), // Changed this line
        reporter: incident.reporterName,
        status: incident.event_status,
        description: incident.description,
        affectedServices: incident.affectedServices,
        // Include original data
        originalData: incident,
      };
    });

    // Set the processed data to state
    setMapData({ branches, atms, incidents });
  };

  const mapStateCoordinates = async () => {
    try {
      const res = await getData(gisStateCoordinates + 52); // Assuming 52 is Bihar's state_id

      if (res && res.length > 0) {
        const stateData = res[0];

        // First, try to parse the coordinates
        let coordinates;
        try {
          coordinates = JSON.parse(stateData.coordinates);
        } catch (e) {
          console.error("Failed to parse coordinates:", e);
          return;
        }

        // Create a proper GeoJSON Feature
        const geoJsonData = {
          type: "Feature",
          properties: {
            name: stateData.state_name,
            state_id: stateData.state_id,
          },
          geometry: coordinates,
        };

        // For debugging
        console.log("State GeoJSON:", geoJsonData);

        setStateGeoJSON(geoJsonData);
      }
    } catch (error) {
      console.error("Error fetching state coordinates:", error);
      toast.error("Failed to load state coordinates");
    }
  };
  console.log(stateGeoJSON, "statejsonn");
  // eslint-disable-next-line no-unused-vars
  const toggleFullscreen = () => {
    if (isFullscreen) {
      handle.exit();
    } else {
      handle.enter();
    }
    setIsFullscreen(!isFullscreen);
  };
  // eslint-disable-next-line no-unused-vars
  const handleCheckboxChange = (key) => {
    setCheckedKeys([]);
    setSelectedPanchayatIds([]);
    //setSelectedDistrictIds([])
    //setActiveDistricts({})

    setSelectedLayers((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));

    if (key === "state") {
      const newSelectAll = !selectedLayers.state;
      setSelectAllDistricts(newSelectAll);
      setShowDistricts(newSelectAll);

      const newActiveDistricts = {};
      const districtPromises = [];
      const districtGisIds = [];

      DistrictList.forEach((district) => {
        newActiveDistricts[district.value] = newSelectAll;

        if (newSelectAll) {
          // Collect GIS IDs when selecting all
          if (district.gis_id) {
            districtGisIds.push(district.gis_id);
          }

          districtPromises.push(
            getData(gisCoordinatesData + district.gis_id)
              .then((response) => {
                if (response && response.length > 0) {
                  const geoJsonData = JSON.parse(response[0].coordinates);
                  setDistrictCoordinates((prev) => ({
                    ...prev,
                    [district.value]: geoJsonData,
                  }));
                }
              })
              .catch((error) => {
                console.error(
                  `Error fetching coordinates for ${district.value}:`,
                  error
                );
                toast.error(`Failed to load coordinates for ${district.value}`);
              })
          );
        }
      });

      // Update selectedDistrictIds based on select all/unselect all
      if (newSelectAll) {
        setSelectedDistrictIds(districtGisIds);
      } else {
        setSelectedDistrictIds([]);
        setDistrictCoordinates({});

      }

      setActiveDistricts(newActiveDistricts);

      if (newSelectAll) {
        setLoadingDistricts(true);
        Promise.all(districtPromises)
          .then(() => {
            // toast.success("All district data loaded successfully", {
            //   position: "top-center",
            // });
          })
          .catch(() => {
            toast.error("Some district data failed to load", {
              position: "top-center",
            });
          })
          .finally(() => {
            setLoadingDistricts(false);
            setLoader(false);
          });
      } else {
        setLoadingDistricts(false);
      }
    }
  };

  // eslint-disable-next-line no-unused-vars
  const handleDistrictToggle = async (districtName) => {
    // First uncheck the state layer if it was checked
    setCheckedKeys([]);
    setSelectedPanchayatIds([]);
    setbmskdetails([]);
    setSelectedDistrictIds([]);
    setSelectAllDistricts(false);

    if (selectedLayers.state) {
      setSelectedLayers((prev) => ({ ...prev, state: false }));
      setSelectAllDistricts(false);

    }

    const newActiveDistricts = {
      ...activeDistricts,
      [districtName]: !activeDistricts[districtName],
    };
    setActiveDistricts(newActiveDistricts);
    setShowDistricts(true);

    const district = DistrictList.find((d) => d.value === districtName);

    if (district) {
      if (!activeDistricts[districtName]) {
        try {
          const response = await getData(gisCoordinatesData + district.gis_id);
          if (response && response.length > 0) {
            const geoJsonData = JSON.parse(response[0].coordinates);
            setDistrictCoordinates((prev) => ({
              ...prev,
              [districtName]: geoJsonData,
            }));
          }

          // Add the GIS ID to selectedDistrictIds when selecting a district
          setSelectedDistrictIds(prev => [...prev, district.gis_id]);
        } catch (error) {
          console.error(
            `Error fetching coordinates for ${districtName}:`,
            error
          );
          toast.error(`Failed to load coordinates for ${districtName}`);
        }
      } else {
        // Remove the GIS ID from selectedDistrictIds when unselecting a district
        setSelectedDistrictIds(prev => prev.filter(id => id !== district.gis_id));

        const newDistrictCoordinates = { ...districtCoordinates };
        delete newDistrictCoordinates[districtName];
        setDistrictCoordinates(newDistrictCoordinates);
      }
    }

    // Check if all districts are now unchecked
    const allUnchecked = DistrictList.every(
      (district) => !newActiveDistricts[district.value]
    );

    if (allUnchecked) {
      setSelectAllDistricts(false);
    } else {
      const allSelected = DistrictList.every(
        (district) => newActiveDistricts[district.value]
      );
      setSelectAllDistricts(allSelected);
    }
  };
  const handleBmskCheckboxChange = (key) => {
    // Clear all region hierarchy selections
    setCheckedKeys([]);
    setSelectedPanchayatIds([]);

    setSelectedRegions([]);

    if (key === "state") {
      const newSelectAll = !bmskSelectAllDistricts;
      setBmskSelectAllDistricts(newSelectAll);

      const newActiveDistricts = {};
      const districtGisIds = [];

      DistrictList.forEach((district) => {
        newActiveDistricts[district.value] = newSelectAll;
        if (newSelectAll && district.gis_id) {
          districtGisIds.push(district.gis_id);
        }
      });

      setBmskActiveDistricts(newActiveDistricts);
      setBmskSelectedDistrictIds(districtGisIds);
      getbmskdetails1(filterDate, newActiveDistricts);
    }
  };

  const handleBmskDistrictToggle = async (districtName) => {
    // Clear region hierarchy selections
    setCheckedKeys([]);
    setSelectedPanchayatIds([]);
    setSelectedRegions([]);
    setSelectedDistrictIds([])
    setSelectedBlockIds([])
    setSelectedVillageIds([])


    const district = DistrictList.find(d => d.value === districtName);
    if (!district) return;

    const newActiveDistricts = {
      ...bmskActiveDistricts,
      [districtName]: !bmskActiveDistricts[districtName]
    };

    setBmskActiveDistricts(newActiveDistricts);

    // Update BMSK selected district IDs
    let newSelectedIds;
    if (newActiveDistricts[districtName]) {
      // Add the district
      newSelectedIds = [...bmskSelectedDistrictIds, district.gis_id];
    } else {
      // Remove the district
      newSelectedIds = bmskSelectedDistrictIds.filter(id => id !== district.gis_id);
    }

    setBmskSelectedDistrictIds(newSelectedIds);

    // Update "Select All" state
    const allSelected = DistrictList.every(
      district => newActiveDistricts[district.value]
    );
    setBmskSelectAllDistricts(allSelected);

    getbmskdetails1(filterDate, newActiveDistricts);
  };
  const fetchDistrictList = async () => {
    // setLoader(true);
    try {
      const response = await getData(districtsInGis);

      console.log("sorteddister", response)
      if (response && Array.isArray(response)) {
        const sortedDistricts = response.sort((a, b) =>
          a.value.localeCompare(b.value)
        );

        setDistrictList(sortedDistricts);
      } else {
        console.error("Invalid banks data format:", response);
        // toast.error("Failed to load banks data");
      }
    } catch (error) {
      console.error("Error fetching banks:", error);
      //toast.error("Failed to load banks data");
    } finally {
      // setLoader(false);
    }
  };
  // eslint-disable-next-line no-unused-vars
  const fetchCoordinates = async (gisId) => {
    try {
      const response = await getData(gisCoordinatesData + gisId);
      if (response && response.length > 0) {
        // Parse the coordinates string into a GeoJSON object
        const geoJsonData = JSON.parse(response[0].coordinates);
        setCoordinates(geoJsonData);
      }
    } catch (error) {
      console.error("Error fetching coordinates:", error);
      toast.error("Failed to load coordinates data");
    }
  };
  const cellStyle = {
    padding: '8px 12px',
    color: 'white',
    textAlign: 'left',
    fontFamily: 'Poppins',
    fontSize: '12px'
  };
  useEffect(() => {
    // When BMSK is inactive, ensure no BMSK districts remain
    if (Object.keys(bmskActiveDistricts).length === 0) {
      setSelectedDistrictIds(prev =>
        prev.filter(id => {
          const district = DistrictList.find(d => d.gis_id === id);
          return !district || !bmskActiveDistricts[district.value];
        })
      );
    }
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [bmskActiveDistricts]);
  // eslint-disable-next-line no-unused-vars
  const geoJsonToLayer = (geoJson) => {
    return L.geoJSON(geoJson, {
      style: {
        color: "#ff7800",
        weight: 2,
        opacity: 1,
        fillColor: "#ff7800",
        fillOpacity: 0.2,
      },
      onEachFeature: (feature, layer) => {
        if (feature.properties && feature.properties.district) {
          layer.bindPopup(feature.properties.district);
        }
      },
    });
  };
  const onSelect = (info) => {
    console.log("selected", info);
  };
  const handleSearchResultSelect = async (item) => {
    try {
      // Make API call to get coordinates for the selected location
      const response = await postDataWithBody(searchshowlatdetails, { name: item.child_id }, {});

      if (response && response.length > 0) {
        // Parse the coordinates from the response
        const coordinates = JSON.parse(response[0].coordinates);

        // Extract the first coordinate pair (assuming it's [longitude, latitude])
        if (coordinates.coordinates && coordinates.coordinates.length > 0) {
          // eslint-disable-next-line no-unused-vars
          const [lng, lat] = coordinates.coordinates[0];

          const geoJsonData = JSON.parse(response[0].coordinates);
          setSearchCoordinates(geoJsonData);


          // Update the search query to show the selected location
          setQuery(item.child_id + " , " + item.parent_first_name);

          // Clear the results
          setResults([]);

        }
      }
    } catch (error) {
      console.error("Error fetching coordinates:", error);
      toast.error("Failed to get coordinates for the selected location");
    }
  };

  useEffect(() => {
    console.log('BMSK Active Districts:', bmskActiveDistricts);
    console.log('Selected District IDs:', selectedDistrictIds);
  }, [bmskActiveDistricts, selectedDistrictIds]);

  const onCheck = async (checkedKeys, info) => {
    setIsLoading(true);
    console.log("Checked keys:", checkedKeys);
    console.log("Check info:", info);
    setBmskActiveDistricts({});
    setBmskSelectAllDistricts(false);
    setBmskSelectedDistrictIds([]);
    setbmskdetails([]);

    const node = info.node;
    const nodeKey = node.key;
    const regionData = regionDataMap.get(nodeKey);

    // Get all keys that are currently checked
    const currentCheckedKeys = Array.isArray(checkedKeys) ?
      checkedKeys :
      checkedKeys.checked || [];

    let newCheckedKeys = [...currentCheckedKeys];
    let newSelectedRegions = [...selectedRegions];
    let newSelectedDistrictIds = [...selectedDistrictIds];
    let newSelectedBlockIds = [...selectedBlockIds];
    let newSelectedPanchayatIds = [...selectedPanchayatIds];
    let newSelectedVillageIds = [...selectedVillageIds];

    try {
      if (regionData) {
        if (info.checked) {
          // Node is being checked
          if (!currentCheckedKeys.includes(nodeKey)) {
            newCheckedKeys.push(nodeKey);
          }

          // Special handling for Bihar node (select all districts)
          if (nodeKey === "52") {
            // First ensure we have all child data loaded
            if (!treeData.find(item => item.key === "52")?.children) {
              // If children aren't loaded yet, force load them
              const biharChildren = await generateTreeNodes({ props: { eventKey: "52" } });
              const newTreeData = [...treeData];
              getNewTreeData(newTreeData, "52", biharChildren, 5);
              setTreeData(newTreeData);

              // Now process all districts
              const allDistrictKeys = biharChildren.map(child => child.key);
              newCheckedKeys = [...new Set([...newCheckedKeys, ...allDistrictKeys])];

              // Add all district GIS IDs to selectedDistrictIds
              const allDistrictGisIds = [];
              biharChildren.forEach(child => {
                const childData = regionDataMap.get(child.key);
                if (childData && childData.gis_id) {
                  allDistrictGisIds.push(childData.gis_id);
                  newSelectedRegions.push({
                    name: childData.name,
                    gis_id: childData.gis_id,
                    id: childData.id,
                    region_type_id: childData.region_type_id,
                    level: childData.level
                  });
                }
              });

              newSelectedDistrictIds = [...new Set([...newSelectedDistrictIds, ...allDistrictGisIds])];
            } else {
              // Children are already loaded, process them
              const biharChildren = treeData.find(item => item.key === "52")?.children || [];
              const allDistrictKeys = biharChildren.map(child => child.key);
              newCheckedKeys = [...new Set([...newCheckedKeys, ...allDistrictKeys])];

              // Add all district GIS IDs to selectedDistrictIds
              const allDistrictGisIds = [];
              biharChildren.forEach(child => {
                const childData = regionDataMap.get(child.key);
                if (childData && childData.gis_id) {
                  allDistrictGisIds.push(childData.gis_id);
                  newSelectedRegions.push({
                    name: childData.name,
                    gis_id: childData.gis_id,
                    id: childData.id,
                    region_type_id: childData.region_type_id,
                    level: childData.level
                  });
                }
              });

              newSelectedDistrictIds = [...new Set([...newSelectedDistrictIds, ...allDistrictGisIds])];
            }
          } else {
            // Handle individual nodes
            await processIndividualNode(nodeKey, regionData, newCheckedKeys, newSelectedRegions,
              newSelectedDistrictIds, newSelectedBlockIds, newSelectedPanchayatIds, newSelectedVillageIds, true);

            // Check if we need to auto-check Bihar state
            if (regionData.level === 1) { // District level
              const biharChildren = treeData.find(item => item.key === "52")?.children || [];
              const allDistrictKeys = biharChildren.map(child => child.key);

              // Check if all districts are now selected
              const allDistrictsSelected = allDistrictKeys.length > 0 &&
                allDistrictKeys.every(districtKey => newCheckedKeys.includes(districtKey));

              // If all districts are selected and Bihar is not already checked, check Bihar
              if (allDistrictsSelected && !newCheckedKeys.includes("52")) {
                newCheckedKeys.push("52");
              }
            }
          }
        } else {
          // Node is being unchecked
          if (nodeKey === "52") {
            // Get all descendant keys recursively
            const getAllDescendantKeys = (nodes, parentKey) => {
              const descendants = [];
              const processNodes = (nodeList) => {
                nodeList.forEach(node => {
                  if (node.key.startsWith(parentKey + '-') || node.key === parentKey) {
                    descendants.push(node.key);
                    if (node.children) {
                      processNodes(node.children);
                    }
                  }
                });
              };
              processNodes(nodes);
              return descendants;
            };

            // Get all Bihar descendants
            const biharDescendants = getAllDescendantKeys(treeData, "52");

            // Remove Bihar and all its descendants from checked keys
            newCheckedKeys = newCheckedKeys.filter(key =>
              !biharDescendants.includes(key) && key !== "52"
            );

            // Clear all selected regions and IDs
            newSelectedRegions = [];
            newSelectedDistrictIds = [];
            newSelectedBlockIds = [];
            newSelectedPanchayatIds = [];
            newSelectedVillageIds = [];
          } else {
            await processIndividualNode(nodeKey, regionData, newCheckedKeys, newSelectedRegions,
              newSelectedDistrictIds, newSelectedBlockIds, newSelectedPanchayatIds, newSelectedVillageIds, false);

            // Check if the unchecked node is a district and Bihar is currently checked
            if (regionData.level === 1 && newCheckedKeys.includes("52")) {
              // Automatically uncheck Bihar when any district is unchecked
              newCheckedKeys = newCheckedKeys.filter(key => key !== "52");
            }
          }
        }
      }

      // Update all states
      setCheckedKeys(newCheckedKeys);
      setSelectedRegions(newSelectedRegions);
      setSelectedDistrictIds(newSelectedDistrictIds);
      setSelectedBlockIds(newSelectedBlockIds);
      setSelectedPanchayatIds(newSelectedPanchayatIds);
      setSelectedVillageIds(newSelectedVillageIds);
      setDistrictId(regionData?.gis_id || "");
    } finally {
      setIsLoading(false);
    }
  };
  const selectedFacilities = facilities
    .filter(f => f.selected)
    .map(f => f.id);
  // Find center point for the map based on available branch locations



  // Define this function before the component or at least before it's used


  // Filter function
  // Replace existing filterFacilitiesInShapes and related calls
  const filterFacilitiesInShapes = (shapes) => {
    if (!shapes || shapes.length === 0) {
      setFilteredFacilities([]);
      return [];
    }
    const validFacilities = facilities.filter(facility =>
      facility.id && facility.id.toString() &&  // Ensure valid ID
      (facility.latitude || facility.longitude ||
        (facility.position && facility.position[0] && facility.position[1]))
    );

    return validFacilities.filter(facility => {
      const point = [
        facility.longitude || facility.position?.[1],
        facility.latitude || facility.position?.[0]
      ];
      return shapes.some(shape => {
        if (shape.properties?.isCircle) {
          const distance = calculateDistance(
            shape.properties.center[0], shape.properties.center[1],
            point[0], point[1]
          );
          return distance <= (shape.properties.radius / 1000);
        }
        return booleanPointInPolygon(point, shape);
      });
    });
  };


  // When shapes are drawn
  const handleDrawCreated = (e) => {
    const shape = e.layer.toGeoJSON();

    if (e.layerType === "circle") {
      const center = e.layer.getLatLng();
      const radius = e.layer.getRadius();
      shape.properties = {
        isCircle: true,
        center: [center.lat, center.lng],
        radius: radius
      };
    }

    const newShapes = [...drawnShapes, shape];
    setDrawnShapes(newShapes);
    const filtered = filterFacilitiesInShapes(newShapes);
    const validFiltered = filtered.filter(f => f.id);

    setFilteredFacilities(validFiltered);
  };

  const handleDrawDeleted = (e) => {
    setDrawnShapes([]);
    setFilteredFacilities([]);
  };
  const clearSearch = () => {
    setQuery('');
    setResults([]);
    setSearchCoordinates(null);
  };


  return (
    <FullScreen handle={handle}>
      {/* <Loader
          show={loader}
          type="body"
          stack="vertical"
          message="Loading Data"
        /> */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          padding: "10px",
          backgroundColor: theme === "light" ? "#ffffff" : "#1f2a44",
          borderRadius: "10px",
          borderBottom: theme === "light" ? "1px solid #ffffff" : "1px solid #4a5f7a",
          marginBottom: "5px",
          position: "relative",
        }}
      >
        {/* Heading */}
        <h1
          style={{
            margin: 0,
            fontSize: "18px",
            fontWeight: "500",
            color: theme === "light" ? "#000000" : "white",
          }}
        >
          GIS Data Management
        </h1>

        {/* Search Input */}
        <div style={{ marginLeft: "60px", position: "relative" }}>
          <input
            type="text"
            placeholder="Search..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            style={{
              padding: "5px",
              borderRadius: "6px",
              border: "1px solid #c5cf63ff",
              backgroundColor: "#f1f1f5ff",
              color: "#0f0f0fff",
              outline: "none",
              fontSize: "14px",
              width: "350px",
              height: '30px'
            }}
          />
          {/* Clear button - show only when there's a query */}
          {query && (
            <button
              onClick={clearSearch}
              style={{
                position: "absolute",
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                background: "none",
                border: "none",
                color: "#666",
                cursor: "pointer",
                fontSize: "16px",
                padding: "0",
                width: "20px",
                height: "20px"
              }}
            >
              ✕
            </button>
          )}
          {/* Suggestions */}
          {query && results.length > 0 && (
            <div
              style={{
                position: "absolute",
                top: "35px",
                left: 0,
                backgroundColor: "#fff",
                border: "1px solid #ccc",
                borderRadius: "6px",
                width: "250px",
                maxHeight: "200px",
                overflowY: "auto",
                zIndex: 1000,
              }}
            >
              {results.map((item, idx) => (
                <div
                  key={idx}
                  style={{
                    padding: "8px 10px",
                    borderBottom: "1px solid #eee",
                    cursor: "pointer",
                    color: "#0f0f0fff",
                  }}
                  onClick={() => {
                    setQuery(item.child_id); // 👈 fill input with selection
                    setResults([]);
                    handleSearchResultSelect(item)
                    console.log("Selected:", item); // you can use this data further
                  }}
                >
                  {item.child_id}{" , "}{item.parent_first_name}

                </div>
              ))}
            </div>
          )}

          {/* Loading Spinner */}
          {loading && (
            <div
              style={{
                position: "absolute",
                top: "8px",
                right: "10px",
                fontSize: "12px",
                color: "#666",
              }}
            >
              ⏳
            </div>
          )}
        </div>
      </div>


      <div
        style={{
          display: "flex",
          height: "100vh",
          fontFamily: "Arial, sans-serif",
        }}
      >

        {/* Map Section */}
        <div style={{ flex: 3, }}>
          <RMMap
            selectedRegions={selectedRegions}
            selectedDistrictIds={selectedDistrictIds}
            selectedBmskids={bmskSelectAllDistricts
              ? DistrictList.map(d => d.gis_id) // All district IDs when "All" is selected
              : bmskSelectedDistrictIds}
            selectedBlockIds={selectedBlockIds}
            selectedPanchayatIds={selectedPanchayatIds}
            selectedVillageIds={selectedVillageIds}
            selectedDistrictId={districtId}
            isLoading={isLoading}
            selectedFacilities={facilities.filter(f => f.selected)}
            mapData1={mapData}
            onLocationSelect={handleLocationSelect}
            drawCircle={drawCircle}
            circleRadius={circleRadius}
            clearCircles={clearCircles}
            facilityCoordinates={facilityCoordinates}
            bmskdetails={bmskdetails}
            drawPolygon={drawPolygon}
            clearPolygons={clearPolygons}
            filteredFacilities2={filteredFacilities}
            handleDrawCreated={handleDrawCreated}
            handleDrawDeleted={handleDrawDeleted}
            clickedPoint={clickedPoint}
            setClickedPoint={setClickedPoint}
            bmskActiveDistricts={bmskActiveDistricts}
            isBmskMode={Object.keys(bmskActiveDistricts).length > 0} // Add this prop
            isKilometerEnabled={isKilometerEnabled}
            searchCoordinates={searchCoordinates}
          />
        </div>

        {/* Right Panel */}
        <div
          style={{
            flex: 1,
            backgroundColor: theme === "light" ? "#ffffff" : "#1f2a44",  //252b48
            borderLeft: theme === "light" ? "1px solid #ffffff" : "1px solid #4a5f7a",
            padding: "10px",
            boxSizing: "border-box",
            overflowY: "auto",
            minWidth: "260px",
            borderRadius: '10px',
            marginLeft: '5px'
          }}
        >
          {/* Tabs */}
          <div style={{ display: "flex", borderBottom: theme === "light" ? '1px solid #ccc' : '1px solid #4a5f7a' }}>
            {["Region", "Search", "Incident"].map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                style={{
                  padding: '10px 12px',
                  backgroundColor: activeTab === tab
                    ? theme === "light"
                      ? "#3a4a65"
                      : "#ffffff"
                    : "transparent",
                  color: activeTab === tab
                    ? theme === "light"
                      ? "#ffffff"
                      : "#000000"
                    : theme === "light"
                      ? "#444"
                      : "#ffffff",
                  border: 'none',
                  cursor: 'pointer',
                  fontSize: '14px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  borderRadius: '5px',
                  borderBottom: activeTab === tab
                    ? `3px solid ${theme === "light" ? "ffffff" : "#4a90e2"}`
                    : 'none'
                }}
              >
                {tab === 'Region' && <MapPin size={16} />}
                {tab === 'Search' && <Search size={16} />}
                {tab === 'Incident' && <AlertTriangle size={16} />}
                {tab}
              </button>
            ))}
          </div>


          {activeTab === "Region" && (
            <>
              <div style={panelStyle}>
                <div
                  style={panelHeader}
                  onClick={() => setShowRegionHierarchy(!showRegionHierarchy)}
                >
                  <span>Region Hierarchy</span>
                  {showRegionHierarchy ? <FaChevronUp /> : <FaChevronDown />}
                </div>
                {showRegionHierarchy && (
                  <Tree
                    onSelect={onSelect}
                    onCheck={onCheck}
                    loadData={(node) => onLoadData(node, { level: 5 })}
                    treeData={treeData}
                    checkable={true}
                    expandedKeys={expandedKeys}
                    onExpand={setExpandedKeys}
                    checkedKeys={checkedKeys}
                    checkStrictly={true}
                    showLine={true}
                    style={{ color: 'black' }}
                  />
                )}

              </div>
              <div style={panelStyle}>
                <div
                  style={panelHeader}
                  onClick={() => setshowbmsk(!showbmsk)}
                >

                  <span>BMSK</span>
                  {showbmsk ? <FaChevronUp /> : <FaChevronDown />}
                </div>
                {showbmsk && (
                  <>
                    <div style={{ padding: '10px', backgroundColor: '#f5f5f5', borderBottom: '1px solid #ddd' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        {/* <label style={{ fontSize: '14px', whiteSpace: 'nowrap' }}>Filter Date:</label> */}
                        <input
                          type="date"
                          value={filterDate}
                          onChange={(e) => {
                            setFilterDate(e.target.value)
                            getbmskdetails1(e.target.value, bmskActiveDistricts);
                          }}
                          max={new Date().toISOString().split('T')[0]}
                          style={{
                            paddingBottom: '20px',
                            border: '1px solid #ddd',
                            borderRadius: '4px',
                            fontSize: '12px',
                            height: 35,
                            paddingLeft: '5px',
                            width: '100%'

                          }}
                        />
                      </div>
                    </div>

                    <div>
                      <div style={{ padding: '10px', }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          {/* <Search size={16} style={{ marginRight: '8px', color: '#666' }} /> */}
                          <input
                            type="text"
                            placeholder="Search districts..."
                            value={districtSearchTerm}
                            onChange={(e) => setDistrictSearchTerm(e.target.value)}
                            style={{
                              width: '100%',
                              padding: '6px',
                              border: '1px solid #ddd',
                              borderRadius: '4px',
                              fontSize: '12px'
                            }}
                          />
                        </div>

                      </div>

                      <div style={{ ...checkboxItem, marginLeft: "40px", marginTop: '5px', marginBottom: '-1px' }}>

                        <input
                          type="checkbox"
                          id="bmsk-state"
                          checked={bmskSelectAllDistricts}
                          onChange={() => handleBmskCheckboxChange("state")}
                          style={{ marginRight: "10px" }}
                        />
                        <label htmlFor="bmsk-state" style={checkboxLabel}>
                          All Districts
                        </label>

                      </div>
                    </div>
                  </>
                )}
                {showbmsk &&

                  DistrictList.filter(district =>
                    district.value.toLowerCase().includes(districtSearchTerm.toLowerCase()) // Updated filter logic
                  )
                    .map((district) => (
                      <div
                        key={district.value}
                        style={{
                          marginLeft: 40,
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <input
                          type="checkbox"
                          id={`bmsk-${district.value}`}
                          checked={bmskActiveDistricts[district.value] || false}
                          onChange={() => handleBmskDistrictToggle(district.value)}
                          style={{ marginRight: "10px" }}
                        />
                        <label htmlFor={`bmsk-${district.value}`} style={checkboxLabel}>
                          {district.value}
                        </label>
                      </div>
                    )
                    )}

              </div>
            </>
          )}

          {activeTab === "Search" && (
            <div style={{
              flex: 1,
              padding: '10px',
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
              width: '100%',
              maxWidth: '350px',
              margin: '0 auto'
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '15px'
              }}>
                <img src={logo} alt="Logo" width={35} height={35} onClick={() => handleDrawCircle(500)} // 500m radius
                  style={{
                    cursor: 'pointer',
                    backgroundColor: activeDrawMode === 'circle'
                      ? '#4a90e2'
                      : theme === 'light' ? '#252b48' : '',
                    borderRadius: '6px',
                    border: activeDrawMode === 'circle' ? '2px solid #fff' : 'none',
                    padding: '4px',
                    transition: 'all 0.3s ease'
                  }} />
                <img src={logo1} alt="Logo" width={35} height={35} onClick={() => handleDrawPolygon()} // 500m radius
                  style={{
                    cursor: 'pointer',
                    backgroundColor: activeDrawMode === 'polygon'
                      ? '#4a90e2'
                      : theme === 'light' ? '#252b48' : '',
                    borderRadius: '6px',
                    border: activeDrawMode === 'polygon' ? '2px solid #fff' : 'none',
                    padding: '4px',
                    transition: 'all 0.3s ease'
                  }} />
                <button
                  style={{
                    padding: '6px 16px',
                    backgroundColor: '#18a3a0',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    fontSize: '14px',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    handleClearCircles();
                    handleClearPolygons();
                    setClickedPoint(null)
                  }}>
                  Clear
                </button>
              </div>
              <div style={{
                backgroundColor: 'white',
                borderRadius: '6px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                overflow: 'hidden',
                width: '100%',
                maxWidth: '350px'
              }}>

                <div style={{
                  backgroundColor: "#18a3a0",
                  color: "white",
                  padding: "8px 12px",
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  fontWeight: "bold",
                }}
                  onClick={() => setShowfacilityHierarchy(!showfacilityHierarchy)}>
                  <span>Facility Hierarchy Data</span>
                  {showfacilityHierarchy ? <FaChevronUp /> : <FaChevronDown />}
                </div>
                {showfacilityHierarchy && (
                  <div style={{ padding: '16px' }}>
                    <div style={{ marginBottom: '16px', position: 'relative' }}>
                      <input
                        type="text"
                        placeholder="Search Facility"
                        value={facilitySearchTerm}
                        onChange={(e) => setFacilitySearchTerm(e.target.value)}
                        style={{
                          width: '70%',
                          padding: '2px',
                          // give enough space for icon
                          border: '1px solid #d9d9d9',
                          borderRadius: '4px',
                          fontSize: '12px',
                          boxSizing: 'border-box' // make sure padding doesn't break width
                        }}
                      />

                      {/* Table Icon */}
                      <div style={{
                        position: 'absolute',
                        right: '10px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '20px',
                        height: '20px',
                        // make icon non-interactive
                        fontSize: '16px',
                        // color: '#888',
                        color: selectedFacilities.length > 0 ? '#000' : '#ccc',
                        cursor: selectedFacilities.length > 0 ? 'pointer' : 'not-allowed'
                      }} onClick={async () => {
                        if (selectedFacilities.length > 0) {
                          await fetchFacilityData(selectedFacilities); // ✅ call the service
                          setshowmodel(true); // open modal
                        }
                      }}>
                        <img src={myImage} alt="table" width={30} height={30} />
                      </div>
                      {showmodel && (
                        <div style={{
                          position: 'fixed',
                          top: 0,
                          left: 0,
                          width: '100%',
                          height: '100%',
                          backgroundColor: 'rgba(0, 0, 0, 0.5)',
                          zIndex: 1000
                        }}>
                          <div style={{
                            position: 'fixed',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            background: '#252b48',
                            borderRadius: '6px',
                            width: '95%',
                            maxWidth: '1200px',
                            maxHeight: '90vh',
                            overflow: 'hidden',
                            boxShadow: '0 10px 30px rgba(0, 0, 0, 0.5)'
                          }}>
                            <div style={{
                              background: '#252b48',
                              color: 'white',
                              padding: '15px 20px',
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              borderBottom: '1px solid #3a4554'
                            }}>
                              <h2 style={{ fontSize: '16px', fontWeight: 'normal', margin: 0, color: '#ffffff' }}>Facility Data</h2>
                              <button
                                style={{
                                  background: 'none',
                                  border: 'none',
                                  color: '#cccccc',
                                  fontSize: '18px',
                                  cursor: 'pointer',
                                  padding: '5px',
                                  width: '25px',
                                  height: '25px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center'
                                }}
                                onClick={() => setshowmodel(false)}
                              >
                                ✕
                              </button>
                            </div>

                            <div style={{
                              background: '#252b48',
                              color: 'white',
                              padding: '0',
                              maxHeight: '70vh',
                              overflow: 'hidden'
                            }}>
                              <div style={{
                                background: '#252b48',
                                padding: '15px 20px',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',

                              }}>
                                <button style={{
                                  background: '#4DB6AC',
                                  color: 'white',
                                  border: 'none',
                                  padding: '6px 14px',
                                  borderRadius: '3px',
                                  cursor: 'pointer',
                                  fontSize: '13px',
                                  fontWeight: 'normal'
                                }}>
                                  Excel
                                </button>
                                <div style={{ position: 'relative' }}>
                                  Search: <input
                                    type="text"
                                    value={modalSearchTerm}
                                    onChange={(e) => setModalSearchTerm(e.target.value)}
                                    style={{
                                      padding: '4px 8px',
                                      border: '1px solid #555',
                                      borderRadius: '3px',
                                      background: '#ffffff',
                                      color: '#333',
                                      width: '150px',
                                      fontSize: '13px',
                                      marginLeft: '5px'
                                    }}
                                  />
                                </div>
                              </div>

                              <div style={{ overflow: 'auto', maxHeight: '400px', marginLeft: '18px', marginRight: '18px', }}>
                                <table style={{
                                  width: '100%',

                                  background: '#252b48',
                                  fontSize: '13px'
                                }}>
                                  <thead>
                                    <tr style={{ background: '#4DB6AC' }}>
                                      <th style={{
                                        background: '#4DB6AC',
                                        color: 'white',
                                        padding: '10px 10px',
                                        textAlign: 'left',
                                        fontWeight: 'normal',

                                        whiteSpace: 'nowrap',
                                        fontFamily: 'Poppins',
                                        fontSize: '12px'
                                      }}>
                                        Facility Name
                                      </th>
                                      <th style={{
                                        background: '#4DB6AC',
                                        color: 'white',
                                        padding: '10px 12px',
                                        textAlign: 'left',
                                        fontWeight: 'normal',

                                        whiteSpace: 'nowrap',
                                        fontFamily: 'Poppins',
                                        fontSize: '12px'
                                      }}>
                                        Facility Address
                                      </th>
                                      <th style={{
                                        background: '#4DB6AC',
                                        color: 'white',
                                        padding: '10px 12px',
                                        textAlign: 'left',
                                        fontWeight: 'normal',

                                        whiteSpace: 'nowrap',
                                        fontFamily: 'Poppins',
                                        fontSize: '12px'
                                      }}>
                                        Contact Name
                                      </th>
                                      <th style={{
                                        background: '#4DB6AC',
                                        color: 'white',
                                        padding: '10px 12px',
                                        textAlign: 'left',
                                        fontWeight: 'normal',

                                        whiteSpace: 'nowrap',
                                        fontFamily: 'Poppins',
                                        fontSize: '12px'
                                      }}>
                                        Contact Email
                                      </th>
                                      <th style={{
                                        background: '#4DB6AC',
                                        color: 'white',
                                        padding: '10px 12px',
                                        textAlign: 'left',
                                        fontWeight: 'normal',

                                        whiteSpace: 'nowrap',
                                        fontFamily: 'Poppins',
                                        fontSize: '12px'
                                      }}>
                                        Contact Phone
                                      </th>
                                      <th style={{
                                        background: '#4DB6AC',
                                        color: 'white',
                                        padding: '10px 12px',
                                        textAlign: 'left',
                                        fontWeight: 'normal',
                                        whiteSpace: 'nowrap',
                                        fontFamily: 'Poppins',
                                        fontSize: '12px'
                                      }}>
                                        Agency Name
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>

                                    {facilityData
                                      .filter((item) =>
                                        Object.values(item)
                                          .join(' ')
                                          .toLowerCase()
                                          .includes(modalSearchTerm.toLowerCase())
                                      )
                                      .map((item, index) => (
                                        <tr key={index} style={{ borderBottom: '1px solid #3a4554' }}>
                                          <td style={cellStyle}>{item.facility_name}</td>
                                          <td style={cellStyle}>{item.facility_address}</td>
                                          <td style={cellStyle}>{item.contact_name}</td>
                                          <td style={cellStyle}>{item.contact_email}</td>
                                          <td style={cellStyle}>{item.contact_phone}</td>
                                          <td style={cellStyle}>{item.agency_name}</td>
                                        </tr>
                                      ))}


                                  </tbody>
                                </table>
                              </div>

                              <div style={{
                                background: '#252b48',
                                padding: '12px 20px',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                color: 'white',
                                fontSize: '13px',
                                borderTop: '1px solid #3a4554'
                              }}>
                                <div>
                                  Showing 1 to 1 of 1 entries
                                </div>
                                <div style={{
                                  display: 'flex',
                                  gap: '5px',
                                  alignItems: 'center'
                                }}>
                                  <button style={{
                                    padding: '4px 8px',
                                    border: '1px solid #555',
                                    background: '#3a4554',
                                    color: '#999',
                                    borderRadius: '3px',
                                    fontSize: '12px',
                                    cursor: 'not-allowed'
                                  }} disabled>
                                    Previous
                                  </button>
                                  <button style={{
                                    padding: '4px 8px',
                                    border: '1px solid #4DB6AC',
                                    background: '#4DB6AC',
                                    color: 'white',
                                    borderRadius: '3px',
                                    fontSize: '12px',
                                    cursor: 'pointer'
                                  }}>
                                    1
                                  </button>
                                  <button style={{
                                    padding: '4px 8px',
                                    border: '1px solid #555',
                                    background: '#3a4554',
                                    color: '#999',
                                    borderRadius: '3px',
                                    fontSize: '12px',
                                    cursor: 'not-allowed'
                                  }} disabled>
                                    Next
                                  </button>
                                </div>
                              </div>
                            </div>

                            <div style={{
                              display: 'flex',
                              justifyContent: 'flex-end',
                              padding: '12px 20px',
                              background: '#252b48',
                              borderTop: '1px solid #3a4554'
                            }}>
                              <button style={{
                                background: '#4DB6AC',
                                color: 'white',
                                border: 'none',
                                padding: '6px 16px',
                                borderRadius: '3px',
                                cursor: 'pointer',
                                fontSize: '13px'
                              }} onClick={() => setshowmodel(false)}>
                                Close
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>


                    <div style={{ padding: '16px' }}>
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: '8px',
                        textAlign: 'left',
                        cursor: 'pointer'
                      }} onClick={toggleSelectAllFacilities}>
                        <input
                          type="checkbox"
                          checked={facilities.every(f => f.selected)}
                          onChange={toggleSelectAllFacilities}
                          style={{
                            marginRight: '8px',
                            cursor: 'pointer'
                          }}
                        />

                        <span style={{
                          fontSize: '14px',
                          fontWeight: 'bold',
                          color: '#D4AF37'
                        }}>Facilities</span>
                      </div>

                      {facilities
                        .filter(facility =>
                          facility.text.toLowerCase().includes(facilitySearchTerm.toLowerCase())
                        )
                        .map((facility) => (
                          <div key={facility.id} style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginBottom: '6px',
                            textAlign: 'left',
                            marginLeft: '10px',
                            cursor: 'pointer'
                          }} onClick={() => toggleFacilitySelect(facility.id)}
                          >
                            <input
                              type="checkbox"
                              checked={facility.selected}
                              onChange={() => toggleFacilitySelect(facility.id)}
                              onClick={(e) => e.stopPropagation()}
                              style={{
                                marginRight: '8px',
                                cursor: 'pointer',

                              }}
                            />
                            <span style={{
                              fontSize: '13px',
                              color: '#D4AF37',
                              marginRight: '4px'
                            }}>⚡</span>
                            <span style={{
                              fontSize: '12px',
                              color: '#333'
                            }}>{facility.text}</span>
                          </div>
                        ))}
                    </div>
                  </div>
                )}
              </div>

              <div>
                <label style={{
                  display: 'block',
                  fontSize: '14px',
                  marginBottom: '4px',
                  color: 'white',
                }}>
                  <input
                    type="checkbox"
                    checked={isKilometerEnabled}
                    onChange={(e) => setIsKilometerEnabled(e.target.checked)}
                    style={{ marginRight: '8px', borderRadius: '8px' }}
                  />
                  Kilometer Range
                </label>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}>
                  <input
                    type="range"
                    min="1"
                    max="100"
                    value={kilometerRange}
                    onChange={(e) => setKilometerRange(parseInt(e.target.value))}
                    style={{
                      flex: 1,
                      accentColor: '#1890ff'
                    }}
                  />
                  <span style={{
                    fontSize: '14px',
                    minWidth: '20px',
                    textAlign: 'center'
                  }}>
                    {kilometerRange}
                  </span>
                </div>
              </div>

              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginTop: '8px'
              }}>
                <button
                  onClick={handleFacilitySearch}
                  style={{
                    padding: '6px 16px',
                    backgroundColor: '#18a3a0',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    fontSize: '14px',
                    cursor: 'pointer'
                  }}
                >
                  Search Facilities
                </button>
                <button
                  onClick={clearFacilitySelections}
                  style={{
                    padding: '6px 16px',
                    backgroundColor: '#18a3a0',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    fontSize: '14px',
                    cursor: 'pointer',
                  }}
                >
                  Clear
                </button>
              </div>

              <div style={{
                backgroundColor: 'white',
                borderRadius: '6px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                overflow: 'hidden',
                width: '100%',
                maxWidth: '350px'
              }}>
                <div style={{
                  backgroundColor: "#18a3a0",
                  color: "white",
                  padding: "8px 12px",
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  fontWeight: "bold",

                }}
                  onClick={() => setshowresourcedata(!showresourcedata)}>
                  <span>Resource Data</span>
                  {showresourcedata ? <FaChevronUp /> : <FaChevronDown />}
                </div>
                {showresourcedata && (
                  <div style={{ padding: '16px' }}>
                    <div style={{
                      fontSize: '12px',
                      marginBottom: '6px',
                      color: '#333',
                      fontWeight: '500'
                    }}>
                      Resource
                    </div>

                    <div style={{ marginBottom: '16px' }}>
                      <select
                        style={{
                          width: '100%',
                          padding: '8px 12px',
                          border: '1px solid #d9d9d9',
                          borderRadius: '4px',
                          fontSize: '12px',
                          backgroundColor: '#fff',
                          fontFamily: 'Poppins'
                        }}
                        value={selectedType}
                        onChange={handleSelectChange}
                      >
                        <option value="">Select type</option>
                        {resourcedata.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.value}
                          </option>
                        ))}
                      </select>
                    </div>

                    <button
                      style={{
                        width: '60%',
                        padding: '10px',
                        backgroundColor: '#18a3a0',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        fontSize: '12px',
                        fontFamily: 'Poppins',
                        cursor: 'pointer',

                      }}
                      onClick={() => searhdisresource()}
                    >
                      Search Resources
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}

          {activeTab === "Incident" && (
            <div style={{
              flex: 1,
              padding: '16px',
              display: 'flex',
              flexDirection: 'column',
              gap: '12px',
              width: '100%',
              maxWidth: '320px',
              margin: '0 auto',
              fontFamily: 'Arial, sans-serif'
            }}>
              <select
                value={selectedIncidentId}
                onChange={(e) => {
                  const newIncidentId = e.target.value;
                  setSelectedIncidentId(newIncidentId);

                  // Reset checkbox and clear events when changing incident
                  setIsChecked(false);
                  setMapData(prev => ({
                    ...prev,
                    events: []
                  }));

                  // If you want to automatically check the box for the new incident, uncomment this:
                  // if (newIncidentId) {
                  //   setIsChecked(true);
                  //   geteventmapdetails(newIncidentId);
                  // }
                }}
                style={{
                  width: '100%',
                  padding: '8px 12px',
                  border: '1px solid #d9d9d9',
                  borderRadius: '4px',
                  fontSize: '12px',
                  marginBottom: '12px',
                  backgroundColor: '#fff',
                  fontFamily: 'Poppins'
                }}
              >
                <option value="">Select an incident</option>

                {[...incidentdata]
                  .sort((a, b) => a.label.localeCompare(b.label)) // sort ascending
                  .map((item) => (
                    <option key={item.value} value={item.value}>
                      {item.label}
                    </option>
                  ))}
              </select>

              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                borderRadius: '4px',
                padding: '1px',
                marginBottom: '12px'
              }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <input
                    type="checkbox"
                    id="show-events"
                    checked={isChecked}
                    onChange={() => {
                      const newChecked = !isChecked;
                      setIsChecked(newChecked);
                      if (!newChecked) {
                        // Clear events when unchecked
                        setMapData(prev => ({
                          ...prev,
                          events: []
                        }));
                      } else if (selectedIncidentId) {
                        // Load event map details when checked
                        geteventmapdetails(selectedIncidentId);
                      }
                    }}

                    style={{
                      marginRight: '8px',
                      cursor: 'pointer'
                    }}
                  />
                  <label htmlFor="show-events" style={{
                    fontSize: '13px',
                    color: 'white',
                    cursor: 'pointer'
                  }}>
                    Show Events
                  </label>
                </div>

                <label
                  style={{
                    padding: '8px 16px',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    fontSize: '14px',
                    fontWeight: '500',
                    cursor: selectedIncidentId ? 'pointer' : 'not-allowed',
                    backgroundColor: selectedIncidentId ? 'transparent' : 'transparent'
                  }}
                  onClick={() => {
                    if (selectedIncidentId) setShowIncident(true);
                    getshowincidata(selectedIncidentId)
                    getcensusdata(selectincideregionid)
                    getregiondata(selectedIncidentId)
                    geteventdata(selectedIncidentId)
                  }}
                >
                  Show Incident
                </label>
              </div>
              {showIncident && (
                <div style={{
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: 'rgba(0,0,0,0.5)',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  zIndex: 1000
                }}>
                  <div style={{
                    backgroundColor: theme === 'dark' ? '#252b48' : '#fff',   //252b48
                    borderRadius: '4px',
                    width: '1000px',
                    maxWidth: '100%',
                    maxHeight: '90vh',
                    overflow: 'auto',
                    boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
                  }}>
                    <div style={{
                      padding: '20px',
                      borderBottom: '1px solid #e0e0e0',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      backgroundColor: theme === 'dark' ? '#252b48' : '#f4f4f4' // Added background color to match your design
                    }}>
                      <h2 style={{
                        margin: 0,
                        fontSize: '20px',
                        fontWeight: '600',
                        color: theme === 'dark' ? 'white' : '#333'
                      }}>Incident Details</h2>

                      <button
                        onClick={() => setShowIncident(false)} // Your close handler function
                        style={{
                          background: 'none',
                          border: 'none',
                          color: theme === 'dark' ? 'white' : '#333',
                          fontSize: '20px',
                          cursor: 'pointer',
                          padding: '0',
                          display: 'flex',
                          alignItems: 'center'
                        }}
                        aria-label="Close modal"
                      >
                        ✕ {/* This is the X icon */}
                      </button>
                    </div>

                    <div style={{ padding: '20px' }}>

                      {basicindata.map((incident, index) => (
                        <div key={index}>
                          <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            marginBottom: '20px',
                            gap: '20px'
                          }}>
                            <div style={{ flex: 1 }}>
                              <div style={{ color: '#ffa100', marginBottom: '5px' }}>Incident Name</div>
                              <div style={{ color: theme === 'dark' ? 'white' : '#333' }}>{incident.name}</div>
                            </div>

                            <div style={{ flex: 1 }}>
                              <div style={{ color: '#ffa100', marginBottom: '5px' }}>Incident Category</div>
                              <div style={{ color: theme === 'dark' ? 'white' : '#333' }}>{incident.cat}</div>
                            </div>

                            <div style={{ flex: 1 }}>
                              <div style={{ color: '#ffa100', marginBottom: '5px' }}>Incident Date & Time</div>
                              <div style={{ color: theme === 'dark' ? 'white' : '#333' }}>{incident.time}</div>
                            </div>
                          </div>

                          <h3 style={{
                            margin: '20px 0 10px 0',
                            fontSize: '14px',
                            color: '#ffa100'
                          }}> Incident Description</h3>
                          <p style={{
                            margin: '0 0 20px 0',
                            lineHeight: '1.5',
                            color: theme === 'dark' ? 'white' : '#333',
                          }}>
                            {incident.description || "NA"}
                          </p>
                        </div>
                      ))}

                      {/* Attribute Section */}
                      <div style={{ marginBottom: '20px' }}>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            cursor: 'pointer',
                            marginBottom: '10px'
                          }}
                          onClick={() => toggleSection('attribute')}
                        >
                          <h2 style={{
                            fontSize: '16px',
                            fontWeight: '600',
                            margin: 0,
                            color: '#ffa100'
                          }}>Census Data</h2>
                          <div style={{ display: 'flex', alignItems: 'center', color: '#ffa100' }}>
                            {expandedSections.attribute ? <FiChevronUp size={24} /> : <FiChevronDown size={24} />}
                          </div>
                        </div>

                        {expandedSections.attribute && (
                          <div style={{ paddingLeft: '1px' }}>
                            <div style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '10px',
                              marginBottom: '12px',
                              justifyContent: 'flex-end'
                            }}>

                              <div style={{
                                fontSize: '14px',
                                fontWeight: '600',
                                color: theme === 'dark' ? 'white' : '#333',
                                whiteSpace: 'nowrap'
                              }}>Search:</div>


                              <input
                                type="text"
                                value={censusSearchTerm}
                                onChange={(e) => setCensusSearchTerm(e.target.value)}
                                style={{
                                  padding: '8px',
                                  border: '1px solid #e0e0e0',
                                  borderRadius: '4px',
                                  fontSize: '14px',
                                  height: '30px'
                                }}

                              />
                            </div>
                            <table style={{
                              width: '100%',
                              borderCollapse: 'collapse',
                              marginBottom: '10px'
                            }}>
                              <thead>
                                <tr style={{
                                  borderBottom: '1px solid #e0e0e0',
                                  backgroundColor: '#18a3a0'
                                }}>
                                  <th style={{ padding: '10px', textAlign: 'left', fontWeight: '600', backgroundColor: '#18a3a0' }}>ID</th>
                                  <th style={{ padding: '10px', textAlign: 'left', fontWeight: '600', backgroundColor: '#18a3a0' }}>Attribute</th>
                                  <th style={{ padding: '10px', textAlign: 'left', fontWeight: '600', backgroundColor: '#18a3a0' }}>Value</th>
                                </tr>
                              </thead>
                              <tbody>
                                {censusdata
                                  .filter(item =>
                                    item.attribute.toLowerCase().includes(censusSearchTerm.toLowerCase()) ||
                                    item.value.toLowerCase().includes(censusSearchTerm.toLowerCase())
                                  )
                                  .map((item, index) => (
                                    <tr key={index} style={{ borderBottom: '1px solid #ccc' }}>
                                      <td style={{ padding: '10px', color: theme === 'dark' ? 'white' : '#333' }}>{index + 1}</td>
                                      <td style={{ padding: '10px', color: theme === 'dark' ? 'white' : '#333', textAlign: 'left' }}>{item.attribute}</td>
                                      <td style={{ padding: '10px', color: theme === 'dark' ? 'white' : '#333', textAlign: 'left' }}>{item.value}</td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>

                          </div>
                        )}
                      </div>

                      <div style={{
                        height: '1px',
                        backgroundColor: '#e0e0e0',
                        margin: '20px 0'
                      }}></div>

                      {/* Affected Regions Section */}
                      <div style={{ marginBottom: '20px' }}>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            cursor: 'pointer',
                            marginBottom: '10px'
                          }}
                          onClick={() => toggleSection('regions')}
                        >
                          <h2 style={{
                            fontSize: '16px',
                            fontWeight: '600',
                            margin: 0,
                            color: '#ffa100'
                          }}>Affected Regions</h2>
                          <div style={{ display: 'flex', alignItems: 'center', color: '#ffa100' }}>
                            {expandedSections.regions ? <FiChevronUp size={24} /> : <FiChevronDown size={24} />}
                          </div>
                        </div>

                        {expandedSections.regions && (
                          <div style={{ paddingLeft: '1px' }}>
                            <div style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '10px',
                              marginBottom: '12px',
                              justifyContent: 'flex-end'
                            }}>
                              {/* Search Label */}
                              <div style={{
                                fontSize: '14px',
                                fontWeight: '600',
                                color: theme === 'dark' ? 'white' : '#333',
                                whiteSpace: 'nowrap'
                              }}>Search:</div>

                              {/* Input Field */}
                              <input
                                type="text"
                                value={regionSearchTerm}
                                onChange={(e) => setRegionSearchTerm(e.target.value)}
                                style={{

                                  padding: '8px',
                                  border: '1px solid #e0e0e0',
                                  borderRadius: '4px',
                                  fontSize: '14px',
                                  height: '30px'
                                }}

                              />
                            </div>
                            <table style={{
                              width: '100%',
                              borderCollapse: 'collapse',
                              marginBottom: '10px'
                            }}>
                              <thead>
                                <tr style={{
                                  borderBottom: '1px solid #e0e0e0',
                                  backgroundColor: '#18a3a0'
                                }}>
                                  <th style={{ padding: '10px', textAlign: 'left', fontSize: '12px', backgroundColor: '#18a3a0' }}>ID</th>
                                  <th style={{ padding: '10px', textAlign: 'left', fontSize: '12px', backgroundColor: '#18a3a0' }}>District</th>
                                  <th style={{ padding: '10px', textAlign: 'left', fontSize: '12px', backgroundColor: '#18a3a0' }}>Block</th>
                                  <th style={{ padding: '10px', textAlign: 'left', fontSize: '12px', backgroundColor: '#18a3a0' }}>Gram Panchayat</th>
                                  <th style={{ padding: '10px', textAlign: 'left', fontSize: '12px', backgroundColor: '#18a3a0' }}>Status</th>
                                  <th style={{ padding: '10px', textAlign: 'left', fontSize: '12px', backgroundColor: '#18a3a0' }}>Updated By</th>
                                  <th style={{ padding: '10px', textAlign: 'left', fontSize: '12px', backgroundColor: '#18a3a0' }}>Updated Date & Time</th>
                                </tr>
                              </thead>
                              <tbody>
                                {regiondata
                                  .filter(item =>
                                    item.dist.toLowerCase().includes(regionSearchTerm.toLowerCase()) ||
                                    item.block.toLowerCase().includes(regionSearchTerm.toLowerCase()) ||
                                    item.name.toLowerCase().includes(regionSearchTerm.toLowerCase()) ||
                                    item.value.toLowerCase().includes(regionSearchTerm.toLowerCase()) ||
                                    item.createdby.toLowerCase().includes(regionSearchTerm.toLowerCase()) ||
                                    item.createdon.toLowerCase().includes(regionSearchTerm.toLowerCase())
                                  )
                                  .map((item, index) => (
                                    <tr key={index} style={{ borderBottom: '1px solid #ccc' }}>
                                      <td style={{ padding: '8px', color: theme === 'dark' ? 'white' : '#333', fontSize: '11px', textAlign: 'left' }}>{item.id}</td>
                                      <td style={{ padding: '8px', color: theme === 'dark' ? 'white' : '#333', fontSize: '11px', textAlign: 'left' }}>{item.dist}</td>
                                      <td style={{ padding: '8px', color: theme === 'dark' ? 'white' : '#333', fontSize: '11px', textAlign: 'left' }}>{item.block}</td>
                                      <td style={{ padding: '8px', color: theme === 'dark' ? 'white' : '#333', fontSize: '11px', textAlign: 'left' }}>{item.name}</td>
                                      <td style={{ padding: '8px', color: theme === 'dark' ? 'white' : '#333', fontSize: '11px', textAlign: 'left' }}>{item.value}</td>
                                      <td style={{ padding: '8px', color: theme === 'dark' ? 'white' : '#333', fontSize: '11px', textAlign: 'left' }}>{item.createdby}</td>
                                      <td style={{ padding: '8px', color: theme === 'dark' ? 'white' : '#333', fontSize: '11px', textAlign: 'left' }}>{item.createdon}</td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                            {/* <div style={{
                              fontSize: '14px',
                              color: 'white',
                              fontStyle: 'italic',
                              paddingLeft: '10px'
                            }}>Showing 0 to 0 of 0 entries</div> */}
                          </div>
                        )}
                      </div>

                      <div style={{
                        height: '1px',
                        backgroundColor: '#e0e0e0',
                        margin: '20px 0'
                      }}></div>

                      {/* Incident Events Section */}
                      <div>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            cursor: 'pointer',
                            marginBottom: '10px'
                          }}
                          onClick={() => toggleSection('events')}
                        >
                          <h2 style={{
                            fontSize: '16px',
                            fontWeight: '600',
                            margin: 0,
                            color: '#ffa100'
                          }}>Incident Events</h2>
                          <div style={{ display: 'flex', alignItems: 'center', color: '#ffa100' }}>
                            {expandedSections.events ? <FiChevronUp size={24} /> : <FiChevronDown size={24} />}
                          </div>
                        </div>

                        {expandedSections.events && (
                          <div style={{ paddingLeft: '1px' }}>
                            <div style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '10px',
                              marginBottom: '12px',
                              justifyContent: 'flex-end'
                            }}>
                              {/* Search Label */}
                              <div style={{
                                fontSize: '14px',
                                fontWeight: '600',
                                color: theme === 'dark' ? 'white' : '#333',
                                whiteSpace: 'nowrap'
                              }}>Search:</div>

                              {/* Input Field */}
                              <input
                                type="text"
                                value={eventSearchTerm}
                                onChange={(e) => setEventSearchTerm(e.target.value)}
                                style={{
                                  padding: '8px',
                                  border: '1px solid #e0e0e0',
                                  borderRadius: '4px',
                                  fontSize: '14px',
                                  height: '30px'
                                }}

                              />
                            </div>
                            <table style={{
                              width: '100%',
                              borderCollapse: 'collapse',
                              marginBottom: '10px'
                            }}>
                              <thead>
                                <tr style={{
                                  borderBottom: '1px solid #e0e0e0',
                                  backgroundColor: '#18a3a0'
                                }}>
                                  <th style={{ padding: '10px', textAlign: 'left', fontSize: '12px', backgroundColor: '#18a3a0' }}>ID</th>
                                  <th style={{ padding: '10px', textAlign: 'left', fontSize: '12px', backgroundColor: '#18a3a0' }}>Incident Name</th>
                                  <th style={{ padding: '10px', textAlign: 'left', fontSize: '12px', backgroundColor: '#18a3a0' }}>Event Date & Time</th>
                                  <th style={{ padding: '10px', textAlign: 'left', fontSize: '12px', backgroundColor: '#18a3a0' }}>Created By</th>
                                  <th style={{ padding: '10px', textAlign: 'left', fontSize: '12px', backgroundColor: '#18a3a0' }}>Event Description</th>
                                </tr>
                              </thead>
                              <tbody>
                                {eventdata
                                  .filter(item =>
                                    item.incident.toLowerCase().includes(eventSearchTerm.toLowerCase()) ||
                                    item.eventTime.toLowerCase().includes(eventSearchTerm.toLowerCase()) ||
                                    item.createdby.toLowerCase().includes(eventSearchTerm.toLowerCase()) ||
                                    item.action.toLowerCase().includes(eventSearchTerm.toLowerCase())
                                  )
                                  .map((item, index) => (
                                    <tr key={index} style={{ borderBottom: '1px solid #ccc' }}>
                                      <td style={{ padding: '8px', color: theme === 'dark' ? 'white' : '#333', fontSize: '11px', textAlign: 'left' }}>{item.id}</td>
                                      <td style={{ padding: '8px', color: theme === 'dark' ? 'white' : '#333', fontSize: '11px', textAlign: 'left' }}>{item.incident}</td>
                                      <td style={{ padding: '8px', color: theme === 'dark' ? 'white' : '#333', fontSize: '11px', textAlign: 'left' }}>{item.eventTime}</td>
                                      <td style={{ padding: '8px', color: theme === 'dark' ? 'white' : '#333', fontSize: '11px', textAlign: 'left' }}>{item.createdby}</td>
                                      <td style={{ padding: '8px', color: theme === 'dark' ? 'white' : '#333', fontSize: '11px', textAlign: 'left' }}>{item.action}</td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          </div>
                        )}
                      </div>

                    </div>

                    <div style={{
                      padding: '15px 20px',
                      display: 'flex',
                      justifyContent: 'flex-end',
                      borderTop: '1px solid #e0e0e0'
                    }}>
                      <button
                        onClick={() => setShowIncident(false)}
                        style={{
                          padding: '8px 16px',
                          background: '#18a3a0',
                          color: '#333',
                          border: 'none',
                          borderRadius: '4px',
                          fontSize: '14px',
                          cursor: 'pointer'
                        }}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>

              )}

              <div style={{
                display: 'flex',
                justifyContent: 'flex-start',
                marginTop: '8px'
              }}>
                <button
                  onClick={() => {

                    setIsChecked(false)
                    setSelectedIncidentId('');
                    setMapData(prev => ({
                      ...prev,
                      events: []  // Clear events data
                    }));
                    setSelectedPanchayatIds([])
                    setClickedPoint(null)

                  }}
                  style={{
                    padding: '8px 16px',
                    backgroundColor: '#18a3a0',
                    color: 'white',
                    border: '1px solid #4DB6AC',
                    borderRadius: '4px',
                    fontSize: '14px',
                    fontWeight: '500',
                    cursor: 'pointer'
                  }}
                >
                  Clear Incident
                </button>
              </div>
            </div>
          )}

          {/* Save Button */}
          {/* <button style={saveButtonStyle}>Save</button> */}
        </div>
      </div>


    </FullScreen>
  );
};

// 🎨 Styles


const panelStyle = {
  backgroundColor: "#e0eff7",
  borderRadius: "5px",
  marginBottom: "15px",
  marginTop: '16px',
  overflow: "hidden",
  border: "1px solid #bcdff1",


};

const panelHeader = {
  backgroundColor: "#18a3a0",
  color: "white",
  padding: "8px 12px",
  cursor: "pointer",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  fontWeight: "bold",
};


const checkboxItem = {
  display: "flex",
  alignItems: "center",
  marginBottom: "8px",
};

const checkboxLabel = {
  display: "flex",
  alignItems: "center",

  cursor: "pointer",
  marginTop: "3px",
};


export default GisMapview;